import ar from "vuetify/lib/locale/ar";
import { Translations } from "./language-translations";
import Role from "../../../views/dashboard/models/Role";
import Order from "../../../views/dashboard/models/Order";
import Offer from "../../../views/dashboard/models/Offer";
import SalePage from "@/assets/js/models/salePage/SalePage";
import Store from "@/assets/js/models/domain/Store";
import Notification from "../../../views/dashboard/models/Notification";
import Ticket from "../../../views/dashboard/models/Ticket";
import Invoice from "../../../views/dashboard/models/Invoice";
import Product from "../../../views/dashboard/models/Product";
import Inventory from "../../../views/dashboard/models/Inventory";
import User from "@/assets/js/models/user/User";
import PreSellPage from "../../../views/dashboard/models/PreSellPage";
import Stripe from "../../../views/dashboard/models/Stripe";
import startCase from "lodash-es/startCase";
import Pixel from "../../../views/dashboard/models/Pixel";
import { product_feed_types } from "../global-constants";
import AllowedCountriesAddon from "../../../views/dashboard/models/AllowedCountriesAddon";
import StorePage from "../../../views/dashboard/models/StorePage";
import * as salePageBlockFills from "./ar/sale_page_blocks";
import SubscriptionPlan from "../models/SubscriptionPlan/SubscriptionPlan";
import network_sdk_account from "./ar/network_sdk_account";
import warehouses_page from "./ar/warehouses_page";
import CheckoutFormSettings from "@/assets/js/models/salePage/FormSettings/CheckoutFormSettings";
import ECommerceSdkAccount from "@/assets/js/models/ECommerceSdk/ECommerceSdkAccount";
import store from "@/assets/js/translations/ar/store";
import referral_program_page from "@/assets/js/translations/ar/referral_program_page";
import subscription_invoices_page from "@/assets/js/translations/ar/subscription_invoices_page";
import GoogleSheet from "@/assets/js/models/GoogleSheet/GoogleSheet";
import google_sheet from "@/assets/js/translations/ar/google_sheet";
import order_page from "@/assets/js/translations/ar/order_page";
import product_page from "@/assets/js/translations/ar/product_page";
import sale_page_page from "@/assets/js/translations/ar/sale_page_page";
import ProductVariation from "@/assets/js/models/product/ProductVariation";
import Option from "@/assets/js/models/salePage/Option";
export default {
  rtl: true,
  ...ar,
  ...Translations.ar,
  sale_page_block_fills: salePageBlockFills.default,
  subscription_invoices: subscription_invoices_page,
  network_sdk_account: network_sdk_account,
  store,
  google_sheet,
  therms: {
    tutorial: 'البرنامج التعليمي',
    category: 'الفئة',
    faq_category: 'فئة الأسئلة المتداولة',
    n_a: 'غير متاح'
  },
  app_bar: {
    store_field: {
      placeholder: 'جميغ المتاجر',
      view_store: 'معاينة المتجر'
    }
  },
  global_text: {
    table: {
      filters: 'المرشحات',
      no_filter_selected: 'لم يتم تحديد أي مرشحات.'
    },
    show_more: 'إظهار أكثر',
    show_less: 'إظهر أقل',
    world_wide: 'جميع أنحاء العالم',
    languages: {
      en: 'الإنجليزية',
      ar: 'العربية'
    },
    pagination: {
      items_per_page: 'مواد لكل صفحة'
    },
    block_tabs: {
      settings: 'الإعدادات',
      content: 'المحتوى',
      style: 'تصميم'
    },
    please_fill_mandatory_fields: 'يرجى ملء الحقول الإلزامية.',
    no_something_found: 'لم يتم العثور على {thing}.',
    something_went_wrong: 'حدث خطأ ما. أعد المحاولة من فضلك.',
    please_wait: 'جاري التحميل انتظر من فضلك',
    total: 'المجموع',
    no_country: 'لا بلد',
    no_result_matching: 'لا توجد نتائج مطابقة',
    yes: 'نعم',
    no: 'لا',
    new_notification: 'لديك رسالة {type} جديدة',
    date: {
      today: 'اليوم',
      yesterday: 'الامس',
      this_month: 'هذا الشهر',
      last_month: 'الشهر الماضي',
      this_week: 'هذا الاسبوع',
      last_week: 'الاسبوع الماضي',
      this_year: 'هذا العام'
    },
    payment_fields: {
      bank_details: {
        country: 'البلد',
        beneficiary_name: 'أسم المستفيد',
        bank_name: 'اسم البنك',
        account_number: 'رقم حساب',
        swift_code: 'رقم التحويل المالي',
        address: 'العنوان'
      },
      payoneer: {
        name: 'الاسم',
        email: 'البريد الالكتروني'
      }
    }
  },
  tutorialDialog: {
    title: 'دروس',
    section_side_bar: 'قسم الشريط الجانبي.',
    tip: 'نصيحة: إذا كنت لا ترغب في رؤية هذه النافذة المنبثقة مرة أخرى ، فالرجاء النقر فوق "حسنا، كل شيء واضح" ، وإذا كنت لا تزال ترغب في مشاهدة المزيد من البرامج التعليمية مثل هذه، فيمكنك العثور عليها في',
    buttons: {
      ok: 'حسنا، كل شيء واضح',
      see_later: 'المشاهدة لاحقا'
    }
  },
  dashboardMenu: {
    your_account_manager: 'مدير حسابك',
    create_ticket: 'أرسل رسالة',
    score: 'مجموع النقاط :',
    points: 'نقطة',
    points_to: 'نقطة للوصول للمستوى',
    points_to_order: 'نقطة واحدة = طلب واحد تم تسليمه',
    level: 'مستوى',
    points_to_level: 'النقاط الى',
    join_whats_app_group: 'Join our whatsapp group',
    overview: {
      title: 'النظرة العامة',
      children: {}
    },
    business_managers: {
      title: 'تطبيقات',
      children: {
        woocommerce: {
          title: 'WooCommerce'
        },
        google_sheet: {
          title: 'Google Sheet'
        },
        google_shopping: {
          title: 'Google Shopping'
        },
        facebook_shopping: {
          title: 'Facebook Shopping'
        }
      }
    },
    offer_page: {
      title: 'العروض',
      children: {
        cod_offers: {
          title: 'عروض الدفع عند الإستلام',
          children: {}
        },
        prepaid_offers: {
          title: 'عروض مسبقة الدفع',
          children: {}
        }
      }
    },
    vip_offers: {
      title: 'العروض الممتازة',
      children: {}
    },
    sale_pages: {
      title: 'صفحات البيع',
      children: {
        original_sale_pages: {
          title: 'صفحات البيع الأصلية'
        },
        generated_sale_pages: {
          title: 'صفحات البيع المنشئة'
        }
      }
    },
    product_sale_pages: {
      title: 'صفحات بيع'
    },
    pre_sell_pages: {
      title: 'صفحات الترويج',
      children: {
        original_pre_sell_pages: {
          title: 'صفحات الترويج الأصلية'
        },
        generated_pre_sell_pages: {
          title: 'صفحات الترويج المنشئة'
        }
      }
    },
    orders: {
      title: 'الطلبات',
      children: {}
    },
    tested_orders: {
      title: 'طلبات تجريبية',
      children: {}
    },
    sale_reports: {
      title: 'إحصائيات',
      children: {}
    },
    trending: {
      title: 'الأكثر رواجا',
      children: {}
    },
    domains: {
      title: 'الدومينات',
      children: {}
    },
    store: {
      title: 'إعدادات المتجر',
      children: {
        store_settings: {
          title: 'المتاجر',
          children: {}
        },
        store_pages: {
          title: 'صفحات المتجر',
          children: {}
        },
        store_layouts: {
          title: 'هياكل المتجر',
          children: {}
        }
      }
    },
    storePages: {
      title: 'صفحات المتجر',
      children: {}
    },
    settings: {
      title: 'الإعدادات',
      children: {}
    },
    call_center: {
      title: 'مركز الاتصال',
      children: {}
    },
    notifications: {
      title: 'الاشعارات',
      children: {}
    },
    support: {
      title: 'الدعم',
      children: {
        faq: {
          title: 'الأسئلة المتداولة'
        },
        ticket: {
          title: 'رسائل الدعم'
        },
        tutorials: {
          title: 'الدروس'
        }
      }
    },
    warehouse: {
      title: 'إعدادات المستودعات',
      children: {
        warehouse: {
          title: 'المستودعات'
        },
        inventory: {
          title: 'المخزون'
        },
        external_api: {
          title: 'External API'
        }
      }
    },
    advertiser: {
      title: 'المعلنين',
      children: {}
    },
    product: {
      title: 'المنتجات',
      children: {}
    },
    inventory_overview: {
      title: 'نظرة عامة على المخزون',
      children: {}
    },
    sellers: {
      title: 'المسوقين',
      children: {}
    },
    referral_program: {
      title: 'برنامج الإحالة',
      children: {
        link: {
          title: 'رابط الإحالة'
        },
        invoices: {
          title: 'فواتير الإحالة'
        },
        payouts: {
          title: 'مدفوعات الإحالة'
        }
      }
    },
    activity_logs: {
      title: 'سجلات النشاط',
      children: {}
    },
    accounting: {
      title: 'محاسبة',
      children: {}
    },
    users: {
      title: 'مستعملون',
      children: {
        user_accounts: {
          title: 'حسابات المستخدم'
        },
        identity_verification: {
          title: 'التحقق من الهوية'
        }
      }
    },
    invoices: {
      title: 'إعدادات عامة',
      children: {
        subscription_invoices: {
          title: 'فواتير الإشتراك'
        },
        settings: {
          title: 'إعدادات الحساب'
        },
        pending_orders: {
          title: 'الطلبات المؤهلة'
        },
        payouts: {
          title: 'المدفوعات'
        },
        warehouse_remittances: {
          title: 'ايداعات المستودعات'
        },
        warehouse_expenses: {
          title: 'مصاريف المستودعات'
        },
        advertiser_commission: {
          title: 'عمولة المعلن'
        },
        referrer_commissions: {
          title: 'الإحالات'
        }
      }
    },
    media_library: {
      title: 'مكتبة الوسائط',
      children: {}
    },
    leads: {
      title: 'Leads',
      children: {}
    },
    offers_requests: {
      title: 'طلبات العروض',
      children: {}
    },
    login: {
      title: 'تسجيل الدخول'
    },
    register: {
      title: 'التسجيل'
    },
    request_password: {
      title: 'طلب كلمة السر'
    },
    reset_password: {
      title: 'تغيير كلمة السر'
    },
    register_confirmation: {
      title: 'تأكيد التسجيل'
    },
    instagram_redirect: {
      title: 'إحالة الإنستاغرام'
    }
  },
  validation_request: {
    check_your_email: 'لقد قمت الآن بإنشاء حسابك بنجاح! يرجى التحقق من بريدك الإلكتروني والرد على استبيان التسجيل لدينا.',
    ps_approve: '<strong>ملاحظة</strong> : ستكون لوحة التحكم الخاصة بك نشطة بعد الموافقة على حسابك.',
    approve_may_take: 'قد تستغرق الموافقة يومًا أو يومين',
    send_instagram_message: 'لتسريع عملية التحقق ، يرجى إرسال رسالة إلينا على الإنستغرام <a dir="ltr" target="_blank" style="color: deepskyblue" href="https://www.instagram.com/maxcom.network">@maxcom.network</a>',
    logout: 'تسجيل الخروج'
  },
  page_not_found: 'الصفحة غير موجودة',
  email_verification: {
    data_check: 'فحص البيانات ... ، من فضلك انتظر.',
    redirection: 'يتم اعادة التوجيه .... الرجاء الانتظار.'
  },
  pagination: {
    all: 'الكل'
  },
  global_errors: {
    mandatory_fields: 'يرجى ملء الحقول الإلزامية.'
  },
  overview: {
    visits: 'الزوار',
    orders: 'الطلبات',
    earnings: 'الأرباح',
    today: 'اليوم',
    yesterday: 'الامس',
    this_month: 'هذا الشهر',
    last_month: 'الشهر الماضي',
    all_time: 'الكل',
    no_earning_today: 'لم يتم تحقيق أرباح اليوم',
    no_earning_yesterday: 'لم يتم تحقيق أرباح بالأمس',
    no_earning_this_month: 'لم يتم تحقيق أرباح هذا الشهر',
    confirmed_earnings: 'الأرباح المؤكدة (الطلبات المسلمة)',
    top_5_offer_earnings: 'أرباحك من أفضل 5 منتجات',
    top_5_country_earnings: 'أرباحك من أفضل 5 دول'
  },
  trending: {
    today: 'اليوم',
    yesterday: 'الامس',
    this_month: 'هذا الشهر',
    last_month: 'الشهر الماضي',
    all_time: 'الكل',
    no_trending_today: 'لا شيء رائج اليوم',
    no_trending_yesterday: 'لا  يكن شيء رائج بالأمس',
    no_trending_this_month: 'لا شيء رائج هذا الشهر',
    confirmed_earnings: 'الأرباح المؤكدة (الطلبات المسلمة)',
    top_5_offer_earnings: 'أرباحك من أفضل 5 عروض',
    top_5_country_earnings: 'أرباحك من أفضل 5 دول',
    top_5_released_offer_payout: 'عمولة أخر 5 عروض',
    top_5_seller_payout: 'أفضل 5 عمولات بائع'
  },
  offer_page: {
    create_offer: 'إضافة عرض حديد',
    no_offers_found: 'لم يتم العثور على أي عروض.',
    you_will_achieve_level: 'أنت الان في {level_name} ، سترى المزيد من العروض عندما تصل إلى المستوى التالي.',
    filter: {
      search: {
        placeholder: 'البحث في العروض ...'
      },
      advertiser: {
        placeholder: 'جميع المعلنين'
      },
      country: {
        placeholder: 'كل البلدان'
      },
      type: {
        option_all: 'كل الأنواع'
      },
      status: {
        option_all: 'كل الحالات'
      },
      commission_type: {
        option_all: 'جميع أنواع العمولات'
      },
      level: {
        option_all: 'كل المستويات'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    },
    offer_item: {
      sale_price: 'ثمن البيع',
      payout: 'العمولة',
      target_countries: 'الدول المستهدفة',
      undefined: 'غير معرفة',
      statistics: {
        title: 'إحصائيات العرض',
        confirmation_rate: {
          tooltip: 'معدل التأكيد'
        },
        delivery_rate: {
          tooltip: 'معدل التوصيل'
        },
        product_quantity: {
          tooltip: 'الكمية المتبقية من المنتج',
          states: {
            low: 'منخفض',
            medium: 'متوسط',
            high: 'مرتفع'
          }
        },
        affiliate_on: {
          tooltip: 'المسوقين للعرض في آخر 7 أيام'
        }
      },
      buttons: {
        details: 'التفاصيل',
        sale_page: 'صفحة البيع',
        review: 'مراجعة',
        pixels: 'بكسلات',
        tracking: 'تتبع',
        edit: 'تعديل',
        delete: 'حذف'
      }
    },
    tabs: {
      offer_id: 'رقم العرض: {id}',
      overview: 'نظرة عامة',
      creatives: 'مرئيات للاعلانات',
      pixels: 'بكسلات',
      tracking_links: 'روابط التتبع'
    },
    dialogs: {
      delete: {
        title: 'حذف العرض',
        content: 'سيؤثر إيقاف العرض مؤقتًا أو حذفه على العناصر المرتبطة به. هل انت متأكد انك تريد المتابعة ؟'
      }
    },
    offer_request_form: {
      review_offer_request: 'طلب مراجعة العرض',
      request_btn: 'أطلب العرض',
      cancel_btn: 'الغاء',
      fields: {
        full_name: {
          title: 'الاسم الكامل',
          placeholder: 'اكتب اسمك الكامل'
        },
        phone: {
          title: 'الهاتف',
          placeholder: 'اكتب رقم هاتفك'
        },
        postal_code: {
          title: 'الرمز البريدي',
          placeholder: 'اكتب الرمز البريدي الخاص بك'
        },
        delivery_address: {
          title: 'عنوان التسليم',
          placeholder: 'اكتب عنوان التسليم'
        },
        country: {
          title: 'الدولة',
          placeholder: 'إختر دولتك'
        },
        city: {
          title: 'المدينة',
          placeholder: 'أكتب إسم مدينتك'
        },
        email: {
          title: 'البريد الالكتروني',
          placeholder: 'example@example.com'
        },
        region: {
          title: 'المنطقة',
          placeholder: 'أكتب إسم منطقتك'
        }
      }
    },
    form: {
      offer_commission_for_statuses: {
        [Order.DELIVERED_STATUS]: 'التسليم',
        [Order.CONFIRMED_STATUS]: 'التأكيد'
      },
      toggle_form: 'انقر هنا لإنشاء عرض.',
      create_offer: {
        title: 'إنشاء العرض',
        subtitle: 'إنشاء عرض جديد'
      },
      update_offer: {
        title: 'تحديث العرض',
        subtitle: 'تحديث العرض'
      },
      step_one: 'الخطوة 1: تقديم المعلومات',
      step_two: 'الخطوة 2: تصميمات المنتجات للإعلانات',
      step_three: 'الخطوة الثالثة: معاينة صفحات المبيعات:',
      you_offer_will_be: 'سيتم حفظ عرضك كمسودة ، وسيتعين عليك تنشيطه بعد إنشاء صفحة البيع.',
      offer_sale_page_list: {
        title: 'عرض قائمة صفحات البيع',
        preview: 'معاينة الصفحة',
        copy: 'نسخ رابط الصفحة'
      },
      create_btn: 'إنشاء العرض',
      save_btn: 'حفظ العرض',
      cancel_btn: 'الغاء',
      duplicate_btn: 'نسخ العرض',
      edit_btn: 'تعديل العرض',
      delete_btn: 'حذف العرض',
      request_btn: {
        shipped: 'تم شحن الطلب',
        new: 'طلب العرض',
        requested: 'تم طلب هذا العرض'
      },
      fields: {
        product: {
          title: 'عرض المنتج',
          placeholder: 'حدد المنتج'
        },
        name: {
          title: 'اسم العرض',
          placeholder: 'اكتب اسمًا'
        },
        type: {
          title: 'نوع العرض'
        },
        status: {
          title: 'حالة العرض'
        },
        payment_type: {
          title: 'الدفع'
        },
        status_for_commission: {
          title: 'العمولة عند'
        },
        description: {
          title: 'وصف العرض',
          placeholder: 'اكتب وصفا'
        },
        level: {
          title: 'المستوى المطلوب للعرض'
        },
        exclusive_users: {
          title: 'للمستخدمين الحصريين للعرض',
          placeholder: 'حدد المستخدمين'
        },
        payout: {
          title: 'الدفع الحاص بالعرض',
          placeholder: 'تعيين الدفع الحاص بالعرض'
        },
        commission: {
          title: 'عمولة الشبكة',
          placeholder: 'تعيين عمولة'
        },
        country: {
          title: 'بلد العرض',
          placeholder: 'اختر دولة'
        },
        creative_ad: {
          title: 'نسخة إعلان المنتج للعرض',
          placeholder: 'اكتب نسخة إعلان المنتج للعرض'
        },
        creative_images: {
          title: 'الصور الإعلانية للعرض',
          placeholder: 'اختر الصور الإعلانية للعرض'
        },
        creative_videos: {
          title: 'الفيديوهات الإعلانية للعرض',
          placeholder: 'اختر الفيديوهات الإعلانية للعرض'
        },
        domain: {
          title: 'نطاق العرض',
          placeholder: 'اختر نطاقا'
        }
      }
    },
    offer_overview: {
      commission_required_status: {
        [Offer.COD_PAYMENT_TYPE]: {
          [Order.DELIVERED_STATUS]: 'عند التسليم',
          [Order.CONFIRMED_STATUS]: 'عند التأكيد'
        },
        [Offer.CARD_PAYMENT_TYPE]: {
          [Order.DELIVERED_STATUS]: 'لكل مبيعة'
        }
      },
      description: 'وصف العرض',
      level: 'مستوى العرض',
      status: 'حالة العرض',
      payout: 'العمولة',
      country: 'البلد المستهدف',
      sale_price: 'ثمن البيع',
      preview_sale_pages: 'معاينة صفحات المبيعات',
      no_sale_page: 'لا توجد صفحة بيع متاحة في هذا العرض.',
      preview_pre_sell_pages: 'معاينة مقالة العرض',
      no_pre_sell_page: 'لا توجد مقالة متاحة في هذا العرض.'
    },
    offer_creatives: {
      ad_copy: 'نسخة إعلانية',
      images: 'الصور',
      videos: 'أشرطة فيديو'
    },
    offer_tracking_links: {
      advanced_options: 'خيارات متقدمة',
      preview: 'معاينة',
      tabs: {
        sale_page: 'إنشاء صفحة البيع',
        pre_sell_page: 'إنشاء صفحة الترويج'
      },
      form: {
        sale_pages: {
          placeholder: 'حدد صفحة البيع'
        },
        pre_sell_pages: {
          placeholder: 'حدد صفحة الترويج'
        },
        domain: {
          our_domain: {
            title: ' رابط الصفحة من مواقعنا :',
            placeholder: 'اختر دومين من مواقعنا'
          },
          your_domain: {
            title: 'رابط الصفحة من مواقعك :',
            placeholder: 'اختر دومين من مواقعك'
          }
        }
      },
      generate_you_sale_page: 'إنشاء صفحة البيع الخاصة بك',
      generate_your_pre_sell_page: 'إنشاء صفحة الترويج الخاصة بك',
      generate_link_placeholder: {
        your_sale_page_link_ready: 'روابطك جاهزة للترويج ( يمكنك تعديل الصفحات في قسم صفحات المبيعات ).',
        your_pre_sell_page_link_ready: 'روابطك جاهزة للترويج ( يمكنك تعديل الصفحات في قسم صفحات الترويج ).',
        sale_page_link: 'رابط صفحة المبيعات:',
        pre_sell_page_link: 'رابط صفحة الترويج:',
        sale_page_will_appear_here: 'سيظهر الرابط الذي تم إنشاؤه هنا.',
        pre_sell_page_will_appear_here: 'سيظهر الرابط الذي تم إنشاؤه هنا.'
      },
      your_generated: 'صفحات المبيعات التي تم إنشاؤها',
      your_generated_pre_sell_pages: 'صفحات الترويج التي تم إنشاؤها',
      no_sale_page_available: 'لا توجد صفحة بيع متاحة.',
      no_pre_sell_page_available: 'لا توجد صفحة ترويج متاحة.'
    },
    offer_pixels: {
      here_you_can_see: 'هنا يمكنك رؤية معرف البكسل الذي قمت بإعداده في إعدادات حسابك ،' + ' ولكن يمكنك أيضًا استبداله بمعرف بكسل جديد لهذا العرض فقط إذا قمت بلصقه هنا.',
      want_other_pixel: 'هل تريد بكسل آخر في صفحة الشكر؟ اتصل بمدير حسابك.',
      only_for_seller: 'هذا القسم مخصص للبائعين / المؤثرين فقط ، قم بتسجيل الدخول كحساب بائع لمشاهدته وتحريره.',
      save: 'حفظ',
      reset: 'إعادة ضبط',
      form: {
        facebook_pixel: {
          title: 'معرف بكسل الفيسبوك',
          placeholder: 'معرف البكسل'
        },
        snapchat_pixel: {
          title: 'معرف بكسل سناب شات',
          placeholder: 'معرف البكسل'
        },
        twitter_pixel: {
          title: 'معرف تويتر بكسل',
          placeholder: 'معرف البكسل'
        },
        google_pixel: {
          title: 'معرف علامة جوجل',
          placeholder: 'GTM-XXXXXXX'
        },
        tiktok_pixel: {
          title: 'معرف بكسل تيكتوك',
          placeholder: 'معرف البكسل'
        },
        postback_url: {
          title: 'عنوان url لإعادة النشر',
          placeholder: 'https://your_postback_url?cid={cid}&payout={payout}'
        }
      }
    }
  },
  pre_sell_page_page: {
    create_pre_Sell_page: 'إنشاء صفحة ترويج جديدة',
    no_pre_sell_pages_found: 'لم يتم العثور على أية صفحات ترويج',
    pre_sell_page_edited_by: 'عدل مؤخرا بواسطة {user_name} ( {user_role} )',
    pre_sell_page_generated_by: 'تم إنشاؤها بواسطة {user_name} ( {user_role} )',
    pre_sell_page_more_info: '<span style="color: var(--app-primary-color)">' + 'الأداء : ' + '<span style="color: var(--app-info-color)">الزيارات</span> {page_visits},&nbsp; ' + '<span style="color: var(--app-success-color)">الطلبات</span> {page_orders},&nbsp; ' + '<span style="color: var(--app-fire-color)">معدل التحويل</span> {conversion_rate} %</span>',
    page_not_up_to_date_alert: 'هذه الصفحة ليست محدثة ، يرجى حفظها أو إلغاء التغييرات بالنقر على زر إلغاء التغييرات أعلاه.',
    dialogs: {
      delete: {
        title: 'حذف المقالة',
        content: 'سيؤثر إيقاف صفحة الترويج مؤقتًا أو حذفها على العناصر المرتبطة بها. هل انت متأكد انك تريد المتابعة ؟'
      }
    },
    filter: {
      search: {
        placeholder: 'تصفية صفحات الترويج ...'
      },
      offers: {
        option_all: 'كل العروض'
      },
      users: {
        option_all: 'جميع المستخدمين'
      },
      sort_by: {
        text: 'ترتيب حسب',
        options: {
          date: 'التاريخ',
          visits: 'الزيارات',
          orders: 'الطلبات',
          clicks: 'النقرات'
        }
      },
      sort: {
        new_to_old: 'من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    },
    pre_sell_page_form: {
      rectangle_image_info: 'الرجاء استخدام صورة مستطيلة لمنظر أفضل.',
      page_title: 'عنوان الصفحة: {title}',
      offer_name: 'إسم العرض: {offer_name}',
      product_sku: 'sku المنتج: {sku}',
      toggle_form: 'انقر هنا لإنشاء صفحة الترويج.',
      create_pre_sell_page: {
        title: 'إنشاء صفحة الترويج',
        subtitle: 'إنشاء صفحات ترويج جديدة'
      },
      update_pre_sell_page: {
        title: 'تعديل صفحة الترويج',
        subtitle: 'تعديل صفحة الترويج'
      },
      buttons: {
        create: 'إنشاء صفحة الترويج',
        delete: 'مسج صفحة الترويج',
        save: 'حفط صفحة الترويج',
        preview: 'معاينة صفحة الترويج',
        duplicate: 'نسخ صفحة الترويج',
        cancel: 'إلغاء',
        reset_form: 'إلغاء التغييرات',
        add_pixel: 'أضافة بكسل'
      },
      steps: {
        one: {
          title: 'الخطوة {step}: معلومات صفحات الترويج'
        },
        two: {
          title: 'الخطوة {step}: أجزاء صفحات الترويج'
        },
        addons: {
          title: 'إضافات الصفحة'
        },
        blocks: {
          title: 'محتوى الصفحة'
        },
        tracking: {
          title: 'تتبع بالبكسل'
        }
      },
      fields: {
        domain: {
          title: 'دومين صفحة الترويج',
          placeholder: 'إختر دومين صفحة الترويج'
        },
        sale_page: {
          title: 'صفحة صفحة الترويج',
          placeholder: 'إختر صفحة صفحة الترويج'
        },
        page_title: {
          title: 'عنوان صفحة الترويج',
          placeholder: 'أكتب عنوان صفحة الترويج'
        },
        page_url_title: {
          title: 'عنوان رابط صفحة الترويج',
          placeholder: 'أكتب عنوان رابط صفحة الترويج'
        },
        add_block: {
          title: 'إضافة محتوى جديد',
          button_title: 'أضف إلى الصفحة'
        }
      },
      addon_fields: {
        show_navbar: {
          title: 'إظهار القائمة navbar'
        },
        sticky_buy_button: {
          title: 'أظهار زر الشراء اللاصق'
        }
      }
    }
  },
  sale_page_page: sale_page_page,
  store_page_page: {
    filter: {
      page: {
        placeholder: 'جميع الصفحات'
      },
      domain: {
        placeholder: 'جميع المتاحر'
      },
      language: {
        placeholder: 'جميع اللغات'
      }
    },
    dialogs: {},
    form: {
      fields: {
        language: {
          title: 'اللغة',
          placeholder: 'إختر لغة'
        },
        type: {
          title: 'إسم الصفحة',
          placeholder: 'إختر إسم صفحة'
        },
        domain: {
          title: 'الدومين',
          placeholder: 'إختر دومين'
        },
        blocks: {
          title: 'محتوى صفحة المتجر',
          buttons: {
            add_block: {
              title: 'أضف الى الصفحة'
            }
          }
        }
      },
      buttons: {
        cancel: 'إلغاء',
        save: 'حفظ الصفحة'
      },
      update_store_page: {
        title: 'تعديل صفحة المتجر'
      }
    }
  },
  order_page,
  sale_reports_page: {
    filter: {
      offers: {
        all_option: 'كل العروض'
      },
      countries: {
        all_option: 'كل البلدان'
      },
      sellers: {
        all_option: 'كل البائعين'
      },
      products: {
        all_option: 'جميع المنتجات'
      },
      call_agents: {
        all_option: 'جميع وكلاء الاتصال'
      },
      by_period: {
        daily: 'يوميًا',
        monthly: 'شهريا'
      }
    },
    chart_colors: {
      earnings: 'الأرباح'
    },
    chart_tooltip: {
      date: 'التاريخ : {v}',
      visits: 'الزيارات : {v}',
      orders: 'الطلبات : {v}',
      sales: 'المبيعات : {v}',
      confirmed: 'المؤكدة : {v}',
      confirmation_rate: 'معدل التأكيد : {v}',
      earnings: 'الأرباح : {v}',
      delivered: 'تم استلامها : {v}',
      delivery_rate: 'معدل الاستلام {v}',
      confirmed_sales: 'المبيعات المؤكدة : {v}',
      confirmed_earnings: 'الأرباح المؤكدة : {v}'
    },
    tables: {
      total: 'المجموع',
      stats_by_country: {
        title: 'إحصائيات الدول',
        visits: 'الزيارات',
        country: 'الدولة',
        conversions: 'الطلبيات',
        payouts: 'العمولات',
        sales_amount_usd: 'المبيعات بالدولار الأمريكي',
        sale_country_currency: 'المبيعات بعملة البلد',
        confirmed_sales: 'المبيعات المؤكدة',
        confirmed_payouts: 'العمولات المؤكدة',
        confirmed_sale_country_currency: 'المبيعات المؤكدة بعملة البلد',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        delivery: 'الاستلام %'
      },
      sale_page_sale_report: {
        title: 'إحصائيات صفحات البيع',
        visit_count: 'الزيارات',
        sale_page_link: 'صفحة البيع',
        lead_count: 'الطلبيات',
        lead_payout_sum: 'العمولات',
        lead_sale_usd_total: 'المبيعات بالدولار الأمريكي',
        lead_sale_total: 'المبيعات بعملة البلد',
        paid_out_orders_count: 'المبيعات المؤكدة',
        paid_out_orders_payout_sum: 'العمولات المؤكدة',
        paid_out_orders_sale_total: 'المبيعات المؤكدة بعملة البلد',
        paid_out_orders_sale_usd_total: 'المبيعات المؤكدة بالدولار الأمريكي',
        delivery_rate: 'الاستلام %'
      },
      stats_by_referrer: {
        title: 'إحصائيات الإحالات',
        visits: 'الزيارات',
        referrer: 'المحيل',
        conversions: 'الطلبيات',
        payouts: 'العمولات',
        sales_amount_usd: 'المبيعات بالدولار الأمريكي',
        confirmed_sales: 'المبيعات بعملة البلد',
        confirmed_payouts: 'العمولات المؤكدة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        delivery: 'الاستلام %'
      },
      stats_by_warehouse: {
        title: 'إحصائيات المستودعات',
        visits: 'الزيارات',
        warehouse: 'المستودع',
        active_products: 'المنتجات النشطة',
        conversions: 'الطلبيات',
        sales_amount_usd: 'المبيعات بالدولار الأمريكي',
        confirmed_sales: 'المبيعات المؤكدة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        call_center_upsells: 'Upsells مركز الاتصال',
        delivery: 'الاستلام %'
      },
      stats_by_offer: {
        title: 'إحصائيات العروض',
        visits: 'الزيارات',
        offer: 'العرض',
        conversions: 'الطلبيات',
        payouts: 'العمولات',
        sales_amount_usd: 'المبيعات بالدولار الأمريكي',
        confirmed_sales: 'المبيعات المؤكدة',
        confirmed_payouts: 'العمولات المؤكدة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        delivery: 'الاستلام %'
      },
      stats_by_product: {
        title: 'إحصائيات المنتج',
        visits: 'الزيارات',
        product: 'المنتج',
        orders: 'الطلبيات',
        sales_amount_usd: 'المبيعات بالدولار الأمريكي',
        delivered_orders: 'الطلبات المسلمة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        delivery: 'الاستلام %',
        upsell_percentage: 'Upsell %'
      },
      stats_by_manager: {
        title: 'إحصائيات المدراء',
        visits: 'الزيارات',
        manager: 'المدراء',
        conversions: 'الطلبيات',
        payouts: 'العمولات',
        sales_amount_usd: 'المبيعات بالدولار الأمريكي',
        confirmed_sales: 'المبيعات المؤكدة',
        confirmed_payouts: 'العمولات المؤكدة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        delivery: 'الاستلام %'
      },
      stats_by_seller: {
        title: 'إحصائيات البائعين',
        visits: 'الزيارات',
        seller: 'البائعون',
        conversions: 'الطلبيات',
        payouts: 'العمولات',
        sales_amount_usd: 'المبيعات بالدولار الأمريكي',
        confirmed_sales: 'المبيعات المؤكدة',
        confirmed_payouts: 'العمولات المؤكدة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        delivery: 'الاستلام %'
      },
      stats_by_call_agent: {
        title: 'إحصائيات وكيل الاتصال',
        visits: 'الزيارات',
        agent: 'وكيل الاتصال',
        orders: 'الطلبيات',
        confirmed_leads: 'Confirmed Leads',
        delivered_orders: 'الطلبات المسلمة',
        upsells: 'Upsells',
        confirmation: 'تأكيد %',
        delivery: 'الاستلام %',
        upsell_percentage: 'Upsell %'
      }
    }
  },
  accounting_page: {
    filter: {
      offers: {
        all_option: 'كل العروض'
      },
      countries: {
        all_option: 'كل البلدان'
      },
      sellers: {
        all_option: 'كل البائعين'
      },
      products: {
        all_option: 'جميع المنتجات'
      },
      call_agents: {
        all_option: 'جميع وكلاء الاتصال'
      },
      by_period: {
        daily: 'يوميًا',
        monthly: 'شهريا'
      }
    },
    chart_colors: {
      earnings: 'الأرباح'
    },
    chart_tooltip: {
      date: 'التاريخ : {v}',
      payouts: 'المدفوعات: {v}',
      products: 'المنتجات: {v}',
      shipping: 'الشحن: {v}',
      taxes: 'الضرائب: {v}',
      profit: 'الربح: {v}',
      orders: 'الطلبات : {v}',
      sales: 'المبيعات : {v}',
      confirmed: 'المؤكدة : {v}',
      confirmation_rate: 'معدل التأكيد : {v}',
      earnings: 'الأرباح : {v}',
      delivered: 'تم استلامها : {v}',
      delivery_rate: 'معدل الاستلام {v}',
      confirmed_sales: 'المبيعات المؤكدة : {v}',
      confirmed_earnings: 'الأرباح المؤكدة : {v}'
    },
    tables: {
      total: 'المجموع',
      stats_by_country: {
        title: 'احصائيات الدول',
        country: 'الدولة',
        confirmed_sales: 'المبيعات المؤكدة',
        payout: 'العمولة',
        product_cost: 'تكلفة المنتج',
        fulfillment_shipping_return: 'الاستيفاء والشحن والإرجاع',
        taxes: 'الضرائب',
        total_cost: 'التكلفة الإجمالية',
        to_pay_to_network: 'للدفع للشبكة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        profit: 'الربح'
      },
      stats_by_warehouse: {
        title: 'احصائيات المستودعات',
        warehouse: 'المستودع',
        confirmed_sales: 'المبيعات المؤكدة',
        payout: 'العمولة',
        product_cost: 'تكلفة المنتج',
        fulfillment_shipping_return: 'الاستيفاء والشحن والإرجاع',
        taxes: 'الضرائب',
        total_cost: 'التكلفة الإجمالية',
        to_pay_to_network: 'للدفع للشبكة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        profit: 'الربح'
      },
      stats_by_offer: {
        title: 'احصائيات العروض',
        offer: 'العرض',
        confirmed_sales: 'المبيعات المؤكدة',
        payout: 'العمولة',
        product_cost: 'تكلفة المنتج',
        fulfillment_shipping_return: 'الاستيفاء والشحن والإرجاع',
        taxes: 'الضرائب',
        total_cost: 'التكلفة الإجمالية',
        to_pay_to_network: 'للدفع للشبكة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        profit: 'الربح'
      },
      stats_by_product: {
        title: 'احصائيات المنتج',
        product: 'المنتج',
        confirmed_sales: 'المبيعات المؤكدة',
        payout: 'العمولة',
        product_cost: 'تكلفة المنتج',
        fulfillment_shipping_return: 'الاستيفاء والشحن والإرجاع',
        taxes: 'الضرائب',
        total_cost: 'التكلفة الإجمالية',
        to_pay_to_network: 'للدفع للشبكة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        profit: 'الربح'
      },
      stats_by_manager: {
        title: 'احصائيات المدراء',
        manager: 'المدراء',
        confirmed_sales: 'المبيعات المؤكدة',
        payout: 'العمولة',
        product_cost: 'تكلفة المنتج',
        fulfillment_shipping_return: 'الاستيفاء والشحن والإرجاع',
        taxes: 'الضرائب',
        total_cost: 'التكلفة الإجمالية',
        to_pay_to_network: 'للدفع للشبكة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        profit: 'الربح'
      },
      stats_by_seller: {
        title: 'احصائيات البائعين',
        seller: 'البائعون',
        confirmed_sales: 'المبيعات المؤكدة',
        payout: 'العمولة',
        product_cost: 'تكلفة المنتج',
        fulfillment_shipping_return: 'الاستيفاء والشحن والإرجاع',
        taxes: 'الضرائب',
        total_cost: 'التكلفة الإجمالية',
        to_pay_to_network: 'للدفع للشبكة',
        confirmed_sales_amount_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
        profit: 'الربح'
      }
    }
  },
  notification_page: {
    form: {
      title: 'إنشاء الإشعار',
      fields: {
        audience_users: {
          title: 'جمهور المستخدمين',
          placeholder: 'حدد المستخدمين من الجمهور'
        },
        title: {
          title: 'عنوان الإشعار',
          placeholder: 'اكتب عنوان الإشعار'
        },
        text: {
          title: 'محتوى الإشعار',
          placeholder: 'اكتب محتوى الإشعار'
        }
      },
      buttons: {
        create: 'إنشاء الإشعار'
      }
    }
  },
  tutorial_page: {
    create_tutorial_btn: 'إنشاء درس جديد',
    tutorial_not_found: 'لم يتم العثور على أي دروس',
    category_form: {
      title: 'إنشاء فئة البرنامج التعليمي',
      fields: {
        name: {
          title: 'فئة',
          placeholder: 'اسم الفئة'
        }
      },
      buttons: {
        save: 'حفظ',
        cancel: 'الغاء'
      }
    },
    delete_dialog: {
      title: 'حذف {type}',
      text: 'هل أنت متأكد أنك تريد حذف {type} ؟'
    },
    show_tutorial_dialog: {
      description: 'الوصف'
    },
    form: {
      title: 'إنشاء برنامج تعليمي',
      fields: {
        category: {
          title: 'فئة البرنامج التعليمي',
          placeholder: 'اختر فئة'
        },
        category_choice_type: {
          options: {
            select_category: 'إختيار فئة موجودة',
            new_category: 'إنشاء فئة جديدة'
          }
        },
        new_category: {
          title: 'فئة برنامج التعليمي جديدة',
          placeholder: 'اكتب فئتك جديدة'
        },
        title: {
          title: 'عنوان البرنامج التعليمي',
          placeholder: 'اكتب عنوان البرنامج التعليمي'
        },
        description: {
          title: 'وصف البرنامج التعليمي',
          placeholder: 'اكتب الوصف'
        },
        video: {
          title: 'فيديو تعليمي',
          placeholder: 'تعيين رابط الفيديو التعليمي'
        },
        on_startup: {
          title: 'اظهار عند بدء التشغيل'
        }
      },
      buttons: {
        create: 'انشاء البرنامج',
        duplicate: 'نسخ البرنامج',
        save: 'حفظ البرنامج',
        edit_category: 'تعديل العنوان',
        edit_tutorial: 'تعديل الدرس',
        delete_category: 'حذف الفئة',
        delete_tutorial: 'حذف الدرس',
        publish: 'أنشر',
        un_publish: 'الغاء النشر',
        cancel: 'الغاء'
      }
    }
  },
  support_page: {
    filter: {
      search: {
        placeholder: 'تصفية ...'
      },
      status: {
        all_option: 'كل الحالات'
      },
      user: {
        all_option: 'جميع المستخدمين'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    },
    faq_category_dialog: {
      title: 'تعديل فئة الاسئلة المتداولة',
      form: {
        fields: {
          name: {
            title: 'اسم فئة الاسئلة المتداولة',
            placeholder: 'أكتب اسم فئة الاسئلة المتداولة'
          }
        },
        buttons: {
          save: 'حفظ',
          cancel: 'الغاء'
        }
      }
    },
    delete_dialog: {
      title: 'حذف {type}',
      text: 'هل أنت متأكد أنك تريد حذف {type} ؟'
    },
    faq: {
      form: {
        create_faq_btn: 'إضافة سؤال',
        title: {
          create: 'إضافة سؤال',
          save: 'تعديل السؤال'
        },
        subtitle: 'أجب عن الأسئلة المتداولة لجمهورك',
        fields: {
          category_choice: {
            options: {
              select_existing: 'فئة جديدة',
              create: 'إختر فئة جديدة'
            }
          },
          category: {
            title: 'فئة',
            placeholder: 'إختر الفئة'
          },
          new_category: {
            title: 'فئة جديدة',
            placeholder: 'أو أنشىء فئة جديدة'
          },
          question: {
            title: 'السؤال',
            placeholder: 'أكتب سؤالاً'
          },
          answer: {
            title: 'الإجابه',
            placeholder: 'أكتب إجابة على السؤال'
          }
        },
        buttons: {
          create: 'إضافة سؤال جديد',
          save: 'حفظ السؤال',
          edit_category: 'تعديل العنوان',
          publish: 'نشر الفئة',
          un_publish: 'الغاء نشر الفئة',
          delete_category: 'حذف الفئة'
        }
      }
    },
    ticket: {
      created_by: '#{id} - أنشأ من قبل {user_name}',
      last_message: 'اخر رسالة : ',
      message_form: {
        fields: {
          message: {
            title: 'رسالة',
            placeholder: 'اكتب رسالتك'
          }
        },
        buttons: {
          send: 'أرسل',
          close: 'أغلق'
        }
      },
      form: {
        create_ticket_btn: 'إنشاء رسالة دعم حديدة',
        toggle_form: 'انقر هنا لإنشاء رسالة دعم.',
        title: 'إنشاء رسالة دعم',
        subtitle: 'لا تجد إجابة؟ تواصل مع المسؤولين هنا',
        fields: {
          type: {
            title: 'نوع المسألة',
            placeholder: 'حدد نوع المسألة'
          },
          description: {
            title: 'الوصف',
            placeholder: 'اشرح طلبك'
          }
        },
        buttons: {
          create: 'إرسال'
        }
      }
    }
  },
  invoices_pending_orders_page: {
    pending_orders: 'الطلبات المؤهلة',
    cod_will_appear_on_delivered: 'ستظهر طلبات الدفع عند الاستلام هنا عندما تكون حالتها في "مسلمة" ، وليست في فاتورة الدفع.',
    prepaid_will_appear_on_shipped: 'ستظهر الطلبات المدفوعة مسبقًا هنا عندما تكون حالتها في "مشحنة" ، وليست في فاتورة الدفع.',
    total_value: 'القيمة الإجمالية للطلبات المحددة هي {value} $',
    you_can_find_here: 'يمكنك العثور هنا على الطلبات المؤهلة الجاهزة للدفع ، ويمكنك تحديد الطلبات والنقر فوق إنشاء الفاتورة إذا كانت القيمة الإجمالية 50 دولار أو أكثر.',
    buttons: {
      generate_payout: 'إنشاء فاتورة العمولة',
      generate_remittance: 'إنشاء فاتورة الايداع',
      generate_expenses: 'إنشاء فاتورة المصاريف',
      generate_commissions: 'إنشاء فاتورة المعلن'
    },
    filter: {
      search: {
        placeholder: 'تصفية الطلبات في الانتظار ...'
      },
      status: {
        all_option: 'جميع حالات الطلب'
      },
      sellers: {
        all_option: 'كل البائعين'
      },
      warehouses: {
        all_option: 'جميع المستودعات'
      },
      advertisers: {
        all_option: 'جميع المعلنين'
      },
      remittance_status: {
        all_option: 'جميع حالات فاتورة الايداع'
      },
      expenses_status: {
        all_option: 'جميع حالات فاتورة المصاريف'
      },
      commission_status: {
        all_option: 'جميع حالات فاتورة عمولة الشبكة'
      },
      payout_status: {
        all_option: 'جميع حالات فاتورة عمولة البائع'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    },
    table: {
      order_id: 'رقم تعريف الطلب',
      order_date: 'تاريخ الطلب',
      order_status: 'حالة الطلب',
      seller_name: 'اسم البائع',
      warehouse_name: 'اسم المستودع',
      advertiser_name: 'اسم المعلن',
      order_country: 'بلد الطلب',
      order_offer_name: 'اسم عرض الطلب',
      payout_value: 'قيمة عمولة البائع',
      payout_status: 'حالة عمولة البائع',
      payout_invoice_id: 'رقم تعريف فاتورة عمولة البائع',
      remittance_value: 'قيمة الايداع',
      remittance_status: 'حالة الايداع',
      remittance_invoice_id: 'رقم تعريف فاتورة الايداع',
      expenses_value: 'قيمة المصاريف',
      expenses_status: 'حالة المصاريف',
      expenses_invoice_id: 'رقم تعريف فاتورة المصاريف',
      commission_value: 'قيمة عمولة الشبكة',
      commission_status: 'حالة عمولة الشبكة',
      commission_invoice_id: 'رقم تعريف فاتورة عمولة الشبكة'
    }
  },
  invoices_referral_page: {
    table_card: {
      title: 'فواتير الإحالات',
      subtitle: 'عندما يحصل المسوقون التابعون لك على مبيعات ويحصلون على أرباحهم، سنعرض لك هنا فواتيرهم والعمولة التي كسبتها من مبيعاتهم (1 دولار لكل طلب مؤهل).<br>' + 'لإنشاء فاتورة إحالة وطلب الدفع، يجب أن تكون قد جمعت عمولات إجمالية قدرها 50 دولارًا أو أكثر من عمولات الإحالات الخاصة بك.<br>' + 'سنقوم كل يوم إثنين بمعالجة دفعات فواتيرك التي تم إنشاؤها للأسبوع السابق.',
      generate_payout_action: {
        text: 'إستخراج العمولة من {count} فواتير',
        button_text: 'إستخراج العمولة'
      },
      table: {
        headers: {
          invoice_id: 'معرف الفاتورة',
          date: 'التاربخ',
          referrer: 'المحيل',
          generated_for: 'أنشأت من أجل',
          referral_commission: 'عمولة المحيل'
        }
      }
    },
    filter: {
      search: {
        placeholder: 'تصفية الفاتورات ...'
      },
      referrer: {
        placeholder: 'جميع المحيلين'
      },
      invoice_status: {
        placeholder: 'جميع الحالات'
      },
      sort: {
        new_to_old: 'من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    },
    payout_invoices: {
      invoice_order: {
        title: 'قائمة الفاتورات المحالة',
        pdf_text: {
          file_name: 'فاتورة عمولة المحيل #{id}',
          pdf_header: 'قائمة الفاتورات المحالة',
          invoice_details: 'تفاصيل الفاتورة',
          payment_info: 'معلومات الدفع',
          invoice_orders: 'فاتورة الطلبات',
          contact_email: 'البريد الإلكتروني للتواصل: {email}',
          web_site: 'الموقع الإلكتروني: {web_site}'
        },
        summary_info: {
          invoice_id: 'معرف الفاتورة',
          date: 'تم إنشاؤه في',
          generated_by: 'تم إنشاؤه بواسطة',
          generated_for: 'تم إنشاؤه من أجل',
          payment_method: 'طريقة الدفع',
          total_commission: 'إجمالي عمولة الشبكة',
          total_payout: 'إجمالي العمولة',
          status: 'حالة الدفع',
          paid_at: 'تم الدفع في',
          payment_id: 'معرف الدفع'
        },
        payment_info: 'معلومات الدفع',
        buttons: {
          close: 'غلق',
          delete: 'حذف الفاتورة',
          download_as_exel: 'تنزيل بصيغة Excel',
          download_as_pdf: 'تنزيل بصيغة PDF'
        },
        table: {
          order_id: 'معرف الطلب',
          order_date: 'تاريخ الطلب',
          order_offer_name: 'إسم عرض الطلب',
          order_country_name: 'إسم بلد الطلب',
          order_confirmed_usd: 'إجمالي المبيعات بالدولار الأمريكي',
          order_commission: 'عمولة الشبكة',
          order_payout: 'عمولة الطلب',
          order_remittance_status: 'حالة التحويل',
          order_status: 'حالة الطلب',
          actions: 'الإجراءات'
        }
      }
    }
  },
  invoices_payout_page: {
    total_paid_earnings: 'إجمالي الأرباح المدفوعة',
    this_month: 'هذا الشهر',
    last_month: 'الشهر الماضي',
    this_year: 'هذه السنة',
    last_year: 'السنة الماضية',
    all_time: 'الكل',
    payout_invoices: {
      title: 'فواتير الدفع',
      subtitle: {
        first_part: '<strong>لإنشاء فاتورة وطلب دفعة ، يجب أن تكون قد جمعت إجمالي 50 دولار أو أكثر من عمولاتك المؤهلة (الطلبات المسلمة)</strong>',
        second_part: 'سنقوم كل يوم اثنين بمعالجة مدفوعات فواتيرك الصادرة عن الأسبوع السابق. <br>' + 'يجوز لنا تعديل فاتورتك لاستبعاد بعض الطلبات غير المؤهلة للدفع ' + 'وستكون متاحة في قائمة الطلبات المعلقة ، ويمكنك تضمينها في فاتورتك التالية'
      },
      mark_selected: 'علم {count} فاتورة (فواتير) للدفع',
      dialogs: {
        remove_order_dialog: {
          title: 'حذف الطلب',
          content: 'هل أنت متأكد أنك تريد حذف هذا الطلب من فاتورته ؟'
        },
        remove_invoice_dialog: {
          title: 'حذف الفاتورة',
          content: 'هل أنت متأكد أنك تريد حذف هذه الفاتورة ؟'
        }
      },
      form: {
        fields: {
          payment_id: {
            placeholder: 'اكتب معرف الدفع'
          },
          payment_method: {
            options: {
              payoneer: 'بايونيير',
              back_transfer: 'تحويل بنكي'
            },
            placeholder: 'اختر طريقة الدفع'
          }
        },
        buttons: {
          pay_invoices: 'دفع الفواتير'
        }
      },
      table: {
        invoice_id: 'رقم تعريف الفاتورة',
        invoice_generated_by: 'أنشئ من قبل',
        invoice_generated_for: 'أنشئ من أجل',
        date: 'تاريخ',
        total: 'إجمالي العمولة (العمولة المؤكدة بالدولار الأمريكي)',
        payment_method: 'طريقة الدفع او السداد',
        status: 'الحالة',
        type: 'النوع',
        actions: 'اجرائات',
        payment_id: 'معرف الدفع'
      },
      referrer_referrers_invoices: {
        title: 'الفاتورات المحيلة للمحيل',
        table: {
          id: 'معرف الفاتورة',
          date: 'التاريخ',
          generatedFor: 'أنشات من أجل',
          totalPayout: 'إجمالي الدفعة',
          referrerCommission: 'عمولة المحيل'
        }
      },
      invoice_order: {
        title: 'قائمة طلبات الفاتورة',
        pdf_text: {
          file_name: 'فاتورة عمولة البائع #{id}',
          pdf_header: 'فاتورة عمولة البائع',
          invoice_details: 'تفاصيل الفاتورة',
          payment_info: 'معلومات الدفع',
          invoice_orders: 'طلبيات الفاتورة',
          contact_email: 'البريد الاكتروني: {email}',
          web_site: 'الموقع الكتروني: {web_site}'
        },
        summary_info: {
          invoice_id: 'رقم تعريف الفاتورة',
          total_commission: 'اجمالي العمولة',
          date: 'التاريخ',
          generated_by: 'أنشئ من قبل',
          generated_for: 'أنشئ من أجل',
          payment_method: 'طريقة الدفع او السداد',
          total_payout: 'إجمالي العمولة',
          status: 'الحالة',
          paid_at: 'دفع في',
          payment_id: 'معرف الدفع'
        },
        payment_info: 'معلومات الدفع',
        buttons: {
          close: 'غلق',
          delete: 'حذف الفاتورة',
          download_as_exel: 'تحميل كملف ايكسيل',
          download_as_pdf: 'تحميل كملف بي دي اف'
        },
        table: {
          order_id: 'رقم تعريف الطلب',
          order_date: 'تاريخ الطلب',
          order_offer_name: 'اسم عرض الطلب',
          order_country_name: 'اسم بلد الطلب',
          order_payout: 'عمولة الطلب',
          order_remittance_status: 'حالة التحويل',
          order_status: 'حالة الطلب',
          actions: 'اجرائات'
        }
      }
    },
    filter: {
      search: {
        placeholder: 'تصفية حسب معرف الفاتورة'
      },
      seller: {
        all_option: 'كل البائعين'
      },
      status: {
        all_option: 'كل الحالات'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    }
  },
  [`invoices_${Invoice.REMITTANCE_TYPE}_page`]: {
    total_paid_earnings: 'إجمالي الأرباح المدفوعة',
    this_month: 'هذا الشهر',
    last_month: 'الشهر الماضي',
    this_year: 'هذه السنة',
    last_year: 'السنة الماضية',
    all_time: 'الكل',
    payout_invoices: {
      title: 'فواتير الدفع',
      subtitle: 'سنقوم كل يوم اثنين بإنشاء فاتورة للطلبات التي تم تسليمها الأسبوع الماضي ، بالإضافة إلى أي طلبات تسليم متأخرة من الأسابيع السابقة.',
      mark_selected: 'علم {count} فاتورة (فواتير) للدفع',
      form: {
        fields: {
          payment_id: {
            placeholder: 'اكتب معرف الدفع'
          },
          payment_method: {
            options: {
              payoneer: 'بايونيير',
              back_transfer: 'تحويل بنكي'
            },
            placeholder: 'اختر طريقة الدفع'
          }
        },
        buttons: {
          pay_invoices: 'دفع الفواتير'
        }
      },
      table: {
        invoice_id: 'رقم تعريف الفاتورة',
        invoice_generated_by: 'أنشئ من قبل',
        invoice_generated_for: 'أنشئ من أجل',
        date: 'تاريخ',
        total: 'إجمالي التحويلات (المبيعات المؤكدة بالدولار الأمريكي)',
        payment_method: 'طريقة الدفع او السداد',
        status: 'الحالة',
        type: 'النوع',
        actions: 'اجرائات',
        payment_id: 'معرف الدفع'
      },
      invoice_order: {
        title: 'قائمة طلبات الفاتورة',
        pdf_text: {
          file_name: 'فاتورة مبيعات المستودع #{id}',
          pdf_header: 'فاتورة مبيعات المستودع',
          invoice_details: 'تفاصيل الفاتورة',
          payment_info: 'معلومات الدفع',
          invoice_orders: 'طلبيات الفاتورة',
          contact_email: 'البريد الاكتروني: {email}',
          web_site: 'الموقع الكتروني: {web_site}'
        },
        summary_info: {
          invoice_id: 'رقم تعريف الفاتورة',
          total_commission: 'اجمالي العمولة',
          date: 'التاريخ',
          generated_by: 'أنشئ من قبل',
          generated_for: 'أنشئ من أجل',
          payment_method: 'طريقة الدفع او السداد',
          total_confirmed_sales_in_usd: 'اجمالي المبيعات المؤكدة بالدولار الأمريكي',
          total_network_commission: 'اجمالي عمولة الشبكة',
          status: 'الحالة',
          paid_at: 'دفع في',
          payment_id: 'معرف الدفع'
        },
        payment_info: 'معلومات الدفع',
        buttons: {
          close: 'غلق',
          delete: 'حذف الفاتورة',
          download_as_exel: 'تحميل كملف ايكسيل',
          download_as_pdf: 'تحميل كملف بي دي اف'
        },
        table: {
          order_id: 'رقم تعريف الطلب',
          order_date: 'تاريخ الطلب',
          order_product_name: 'اسم منتوج الطلب',
          order_country_name: 'اسم بلد الطلب',
          order_payout: 'عمولة الطلب',
          order_confirmed_usd: 'اجمالي المبيعات المؤكدة بالدولار الأمريكي',
          order_status: 'حالة الطلب',
          actions: 'اجرائات'
        }
      }
    },
    filter: {
      search: {
        placeholder: 'تصفية حسب معرف الفاتورة'
      },
      warehouse: {
        all_option: 'كل المستودعات'
      },
      status: {
        all_option: 'كل الحالات'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    }
  },
  [`invoices_${Invoice.COMMISSION_TYPE}_page`]: {
    total_paid_earnings: 'إجمالي الأرباح المدفوعة',
    this_month: 'هذا الشهر',
    last_month: 'الشهر الماضي',
    this_year: 'هذه السنة',
    last_year: 'السنة الماضية',
    all_time: 'الكل',
    payout_invoices: {
      title: 'فواتير الدفع',
      subtitle: {
        second_part: 'سنقوم كل يوم اثنين بإنشاء فاتورة للطلبات التي تم تسليمها الأسبوع الماضي ، بالإضافة إلى أي طلبات تسليم متأخرة من الأسابيع السابقة.'
      },
      mark_selected: 'علم {count} فاتورة (فواتير) للدفع',
      dialogs: {
        remove_order_dialog: {
          title: 'Delete order',
          content: 'Are you sure you want to delete this order from it\'s invoice ?'
        },
        remove_invoice_dialog: {
          title: 'Delete invoice',
          content: 'Are you sure you want to delete this invoice ?'
        }
      },
      form: {
        fields: {
          payment_id: {
            placeholder: 'اكتب معرف الدفع'
          },
          payment_method: {
            options: {
              payoneer: 'بايونيير',
              back_transfer: 'تحويل بنكي'
            },
            placeholder: 'اختر طريقة الدفع'
          }
        },
        buttons: {
          pay_invoices: 'دفع الفواتير'
        }
      },
      table: {
        invoice_id: 'رقم تعريف الفاتورة',
        invoice_generated_by: 'أنشئ من قبل',
        invoice_generated_for: 'أنشئ من أجل',
        date: 'تاريخ',
        total: 'إجمالي العمولات (العمولات المؤكدة بالدولار الأمريكي)',
        payment_method: 'طريقة الدفع او السداد',
        status: 'الحالة',
        type: 'النوع',
        actions: 'اجرائات',
        payment_id: 'معرف الدفع'
      },
      invoice_order: {
        title: 'قائمة طلبات الفاتورة',
        pdf_text: {
          file_name: 'فاتورة عمولة المعلن #{id}',
          pdf_header: 'فاتورة عمولة المعلن',
          invoice_details: 'تفاصيل الفاتورة',
          payment_info: 'معلومات الدفع',
          invoice_orders: 'طلبيات الفاتورة',
          contact_email: 'البريد الاكتروني: {email}',
          web_site: 'الموقع الكتروني: {web_site}'
        },
        summary_info: {
          invoice_id: 'رقم تعريف الفاتورة',
          total_commission: 'اجمالي العمولة',
          date: 'التاريخ',
          generated_by: 'أنشئ من قبل',
          generated_for: 'أنشئ من أجل',
          payment_method: 'طريقة الدفع او السداد',
          total_confirmed_sales_in_usd: 'اخمالي العمولة اللازم دفعها',
          total_network_commission: 'اخمالي عمولة الشبكة',
          status: 'الحالة',
          paid_at: 'دفع في',
          payment_id: 'معرف الدفع'
        },
        payment_info: 'معلومات الدفع',
        buttons: {
          close: 'غلق',
          delete: 'حذف الفاتورة',
          download_as_exel: 'تحميل كملف ايكسيل',
          download_as_pdf: 'تحميل كملف بي دي اف'
        },
        table: {
          order_id: 'رقم تعريف الطلب',
          order_date: 'تاريخ الطلب',
          order_product_name: 'اسم منتوج الطلب',
          order_country_name: 'اسم بلد الطلب',
          order_payout: 'عمولة الطلب',
          order_confirmed_usd: 'المبيعات المؤكدة بالدولار الأمريكي',
          order_commission: 'عمولة الشبكة',
          order_status: 'حالة الطلب',
          order_total_commission: 'اجمالي العمولة',
          actions: 'اجرائات'
        }
      }
    },
    filter: {
      search: {
        placeholder: 'تصفية حسب معرف الفاتورة'
      },
      advertiser: {
        all_option: 'كل المعلنين'
      },
      status: {
        all_option: 'كل الحالات'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    }
  },
  [`invoices_${Invoice.EXPENSES_TYPE}_page`]: {
    total_paid_earnings: 'إجمالي الأرباح المدفوعة',
    this_month: 'هذا الشهر',
    last_month: 'الشهر الماضي',
    this_year: 'هذه السنة',
    last_year: 'السنة الماضية',
    all_time: 'الكل',
    payout_invoices: {
      title: 'فواتير الدفع',
      subtitle: 'سنقوم كل يوم اثنين بإنشاء فاتورة للطلبات التي تم تسليمها الأسبوع الماضي ، بالإضافة إلى أي طلبات تسليم متأخرة من الأسابيع السابقة.',
      mark_selected: 'علم {count} فاتورة (فواتير) للدفع',
      form: {
        fields: {
          payment_id: {
            placeholder: 'اكتب معرف الدفع'
          },
          payment_method: {
            options: {
              payoneer: 'بايونيير',
              back_transfer: 'تحويل بنكي'
            },
            placeholder: 'اختر طريقة الدفع'
          }
        },
        buttons: {
          pay_invoices: 'دفع الفواتير'
        }
      },
      table: {
        invoice_id: 'رقم تعريف الفاتورة',
        invoice_generated_by: 'أنشئ من قبل',
        invoice_generated_for: 'أنشئ من أجل',
        date: 'تاريخ',
        total: 'إجمالي النفقات (النفقات المؤكدة بالدولار الأمريكي)',
        payment_method: 'طريقة الدفع او السداد',
        status: 'الحالة',
        type: 'النوع',
        actions: 'اجرائات',
        payment_id: 'معرف الدفع'
      },
      invoice_order: {
        title: 'قائمة طلبات الفاتورة',
        pdf_text: {
          file_name: 'فاتورة مصاريف المستودع #{id}',
          pdf_header: 'فاتورة مصاريف المستودع',
          invoice_details: 'تفاصيل الفاتورة',
          payment_info: 'معلومات الدفع',
          invoice_orders: 'طلبيات الفاتورة',
          contact_email: 'البريد الاكتروني: {email}',
          web_site: 'الموقع الكتروني: {web_site}'
        },
        summary_info: {
          invoice_id: 'رقم تعريف الفاتورة',
          total_commission: 'اجمالي العمولة',
          date: 'التاريخ',
          generated_by: 'أنشئ من قبل',
          generated_for: 'أنشئ من أجل',
          payment_method: 'طريقة الدفع او السداد',
          total_confirmed_sales_in_usd: 'اجمالي المبيعات المؤكدة بالدولار الأمريكي',
          total_network_commission: 'اجمالي عمولة الشبكة',
          status: 'الحالة',
          paid_at: 'دفع في',
          payment_id: 'معرف الدفع'
        },
        payment_info: 'معلومات الدفع',
        buttons: {
          close: 'غلق',
          delete: 'حذف الفاتورة',
          download_as_exel: 'تحميل كملف ايكسيل',
          download_as_pdf: 'تحميل كملف بي دي اف'
        },
        table: {
          order_id: 'رقم تعريف الطلب',
          order_date: 'تاريخ الطلب',
          order_product_name: 'اسم منتوج الطلب',
          order_country_name: 'اسم بلد الطلب',
          order_payout: 'عمولة الطلب',
          order_confirmed_usd: 'اجمالي المبيعات المؤكدة بالدولار الأمريكي',
          order_status: 'حالة الطلب',
          actions: 'اجرائات'
        }
      }
    },
    filter: {
      search: {
        placeholder: 'تصفية حسب معرف الفاتورة'
      },
      warehouse: {
        all_option: 'كل المستودعات'
      },
      status: {
        all_option: 'كل الحالات'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    }
  },
  product_page,
  inventory_overview_page: {
    day: 'يوم (أيام)',
    no_stock_available: 'لا يوجد مخزون متاح',
    stock_available: 'مخزون متاح',
    will_empty_out_soon: 'سوف تفرغ قريبا',
    filter: {
      search: {
        placeholder: 'تصفية المنتجات ...'
      },
      country: {
        placeholder: 'كل البلدان'
      },
      warehouse: {
        placeholder: 'جميع المستودعات'
      },
      product: {
        placeholder: 'جميع المنتجات'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    },
    table: {
      sku: 'SKU',
      product_name: 'اسم المنتج',
      country: 'البلد',
      warehouse: 'المستودع',
      available_quantity: 'الكمية المتوفرة',
      last_daily_sales: 'آخر المبيعات اليومية',
      last_weekly_sales: 'آخر المبيعات الأسبوعية',
      out_of_stock: 'نفذ من المخزون في'
    }
  },
  call_center_page: {
    create_call_agent_btn: 'إنشاء عميل إتصال جديد',
    filter: {
      search: {
        placeholder: 'تصفية قائمة وكلاء المكالمات'
      },
      country: {
        all_option: 'كل البلدان'
      },
      warehouse: {
        all_option: 'جميع المستودعات'
      }
    },
    form: {
      toggle_form: 'انقر هنا لإنشاء وكيل الاتصال.',
      no_result_matching: 'لا توجد نتائج مطابقة',
      create_call_agent: {
        title: 'إنشاء وكيل اتصال',
        subtitle: 'إنشاء وكيل اتصال جديد'
      },
      update_call_agent: {
        title: 'تعديل وكيل الاتصال',
        subtitle: 'تعديل وكيل الاتصال'
      },
      buttons: {
        create: 'إنشاء وكيل اتصال',
        save: 'حفظ وكيل الاتصال',
        cancel: 'الغاء'
      },
      fields: {
        full_name: {
          title: 'الاسم الكامل',
          placeholder: 'أكتب الاسم الكامل'
        },
        company_name: {
          title: 'اسم الشركة',
          placeholder: 'أكتب اسم الشركة'
        },
        country: {
          title: 'الدولة',
          placeholder: 'اختر الدولة'
        },
        user_name: {
          title: 'اسم المستخدم',
          placeholder: 'أكتب اسم المستخدم'
        },
        email: {
          title: 'البريد الالكتروني',
          placeholder: 'example@example.com'
        },
        phone: {
          title: 'الهاتف',
          placeholder: 'أكتب رقم الهاتف'
        },
        password: {
          title: 'كلمه المرور',
          placeholder: 'أكتب كلمة المرور'
        },
        confirmation: {
          title: 'تأكيد كلمة المرور',
          placeholder: 'كرر كلمة المرور'
        },
        language: {
          title: 'اللغة',
          placeholder: 'حدد لغة التحدث'
        },
        warehouse: {
          title: 'مستودع',
          placeholder: 'حدد المستودع'
        },
        assigned_products: {
          title: 'المنتجات المخصصة',
          placeholder: 'حدد المنتجات المخصصة'
        }
      }
    },
    table_card: {
      title: 'وكلاء الاتصال',
      subtitle: 'إدارة وكلاء الاتصال',
      set_selected_status_to: 'عيِّن حالة {count} وكلاء الاتصال الى:',
      change_assigned_for_selected: 'تغيير المنتجات المعينة ل {count} وكلاء اتصال إلى:',
      buttons: {
        apply: 'تطبيق',
        assigned_products: 'تعيين المنتجات'
      },
      fields: {
        assigned_products: {
          content_text: '(+{n} اخرين)',
          select_all: 'اختر الكل',
          no_products: 'لا توجد منتجات'
        }
      },
      table: {
        creation_date: 'تاريخ الإنشاء',
        warehouse: 'المستودع',
        Language_used: 'اللغة المستخدمة',
        name: 'اسم',
        contact_name: 'اسم جهة الاتصال',
        contact_details: 'بيانات المتصل',
        country: 'الدولة',
        assigned_products: 'المنتجات المخصصة',
        status: 'الحالة',
        actions: 'الاجراءات'
      }
    },
    call_agent_form: {
      create_call_agent: {
        title: 'إنشاء وكيل اتصال',
        subtitle: 'قم بإنشاء وكيل الاتصال الرئيسي لهذا المستودع'
      },
      update_call_agent: {
        title: 'تعديل وكيل اتصال',
        subtitle: 'تعديل وكيل اتصال'
      }
    }
  },
  warehouse_page: warehouses_page,
  offer_request_page: {
    filter: {
      offer: {
        all_option: 'كل العروض'
      },
      influencer: {
        all_option: 'كل المؤثرين'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    },
    table_card: {
      set_selected_status_to: 'عيِّن حالة {count} طلبات الى:',
      buttons: {
        apply: 'تطبيق'
      },
      table: {
        request_date: 'تاريخ الطلب',
        influencer: 'المؤثر',
        offer: 'العرض',
        status: 'الحالة',
        actions: 'الاجراءات'
      },
      influencer_Details: {
        title: 'تفاصيل المؤثر',
        buttons: {
          save: 'حفظ',
          cancel: 'الغاء'
        }
      }
    },
    dialogs: {
      delete: {
        title: 'حذف طلب العرض',
        content: 'هل أنت متأكد أنك تريد حذف طلب العرض هذا ؟'
      }
    }
  },
  activity_logs_page: {
    filter: {
      search: {
        placeholder: 'تصفية الأنشطة حسب المستخدم ...'
      }
    },
    before_change: 'قبل التغيير',
    after_change: 'بعد التغيير',
    table: {
      field_name: 'اسم الحقل',
      field_content: 'محتوى الحقل'
    }
  },
  advertiser_page: {
    create_advertiser_btn: 'إنشاء معلن جديد',
    filter: {
      search: {
        placeholder: 'تصفية المعلنين ...'
      },
      status: {
        all_option: 'كل الحالات'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      }
    },
    form: {
      toggle_form: 'انقر هنا لإنشاء معلن.',
      create_advertiser: {
        title: 'إنشاء معلن',
        subtitle: 'إنشاء معلن جديد'
      },
      update_advertiser: {
        title: 'تعديل معلن',
        subtitle: 'تعديل معلن'
      },
      fields: {
        warehouse: {
          title: 'المستودع',
          placeholder: 'حدد مستودع المعلن'
        },
        country: {
          title: 'الدولة',
          placeholder: 'حدد بلد المعلن'
        },
        user_name: {
          title: 'اسم المستخدم',
          placeholder: 'اكتب اسم المستخدم'
        },
        contact_name: {
          title: 'اسم جهة الاتصال',
          placeholder: 'اكتب اسم جهة الاتصال'
        },
        email: {
          title: 'البريد الالكتروني',
          placeholder: 'example@example.com'
        },
        password: {
          title: 'كلمه السر',
          placeholder: 'اكتب كلمة المرور'
        },
        confirmation: {
          title: 'تأكيد كلمة المرور',
          placeholder: 'اكتب تأكيد كلمة المرور'
        },
        phone: {
          title: 'الهاتف',
          placeholder: 'اكتب رقم الهاتف'
        },
        skype: {
          title: 'سكايب',
          placeholder: 'اكتب معرف سكايب'
        }
      },
      buttons: {
        create: 'إنشاء معلن',
        duplicate: 'نسخ معلن',
        save: 'حفظ المعلن',
        cancel: 'الغاء'
      }
    },
    table_card: {
      set_selected_status_to: 'عيِّن حالة {count} طلبات الى:',
      buttons: {
        apply: 'تطبيق'
      },
      table: {
        creation_date: 'تاريخ الإنشاء',
        advertiser_type: 'نوع المعلن',
        advertiser_name: 'اسم المعلن',
        contact_name: 'اسم جهة الاتصال',
        contact_details: 'بيانات المتصل',
        status: 'الحالة',
        action: 'الاجراءات'
      }
    }
  },
  seller_page: {
    filter: {
      search: {
        placeholder: 'تصفية البائعين ...'
      },
      role: {
        all_option: 'كل الأدوار'
      },
      status: {
        all_option: 'كل الحالات'
      },
      country: {
        all_option: 'كل البلدان'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      },
      logged_status: {
        last_logged_in: 'آخر تسجيل دخول',
        first_logged_in: 'أول تسجيل دخول'
      }
    },
    table_card: {
      set_selected_status_to: 'عين حالة {count} بائعين الى : ',
      set_selected_manager_to: 'عين مدير {count} بائعين الى : ',
      not_set: '<span class="red--text">غير محدد</span>',
      buttons: {
        apply: 'تطبيق'
      },
      fields: {
        manager: {
          placeholder: 'حدد المدير'
        }
      },
      no_manager: 'لا مدير',
      more_info: {
        country: 'البلد',
        skype_id: 'هوية السكايب',
        company_name: 'اسم الشركة',
        level: 'المستوى',
        experience_description: 'وصف الخبرة',
        seller_status: 'حالة البائع',
        subscribed_to_news_letter: 'اشترك في الرسالة الإخبارية؟',
        youtube_profile: 'الملف الشخصي لاليوتيوب',
        instagram_profile: 'الملف الشخصي لالانستغرام'
      },
      table: {
        more_info: 'مزيد من المعلومات',
        sign_up_date: 'تاريخ التسجيل',
        role: 'الدور',
        user_name: 'اسم المستخدم',
        full_name: 'الاسم الكامل',
        contact_details: 'بيانات المتصل',
        country: 'البلد',
        last_month_confirmed_sales: 'آخر 30 يومًا مبيعات مؤكدة',
        assigned_manager: 'المدير المعين',
        status: 'الحالة'
      }
    }
  },
  referral_program_page: referral_program_page,
  user_page: {
    filter: {
      search: {
        placeholder: 'تصفية البائعين ...'
      },
      role: {
        all_option: 'كل الأدوار'
      },
      status: {
        all_option: 'كل الحالات'
      },
      country: {
        all_option: 'كل البلدان'
      },
      sort: {
        new_to_old: ' من الجديد إلى القديم',
        old_to_new: 'من القديم إلى الجديد'
      },
      logged_status: {
        last_logged_in: 'آخر تسجيل دخول',
        first_logged_in: 'أول تسجيل دخول'
      }
    },
    table_card: {
      tabs: {
        manage_user: {
          tab_title: 'إدارة المستخدمين',
          set_selected_status_to: 'عين حالة {count} بائعين الى : ',
          buttons: {
            apply: 'تطبيق'
          },
          more_info: {
            country: 'البلد',
            skype_id: 'هوية السكايب',
            company_name: 'اسم الشركة',
            level: 'المستوى',
            experience_description: 'وصف الخبرة',
            seller_status: 'حالة البائع',
            subscribed_to_news_letter: 'اشترك في الرسالة الإخبارية؟',
            youtube_profile: 'الملف الشخصي لاليوتيوب',
            instagram_profile: 'الملف الشخصي لالانستغرام'
          },
          table: {
            more_info: 'مزيد من المعلومات',
            sign_up_date: 'تاريخ التسجيل',
            role: 'الدور',
            user_name: 'اسم المستخدم',
            full_name: 'الاسم الكامل',
            contact_details: 'بيانات المتصل',
            country: 'البلد',
            last_month_confirmed_sales: 'آخر 30 يومًا مبيعات مؤكدة',
            status: 'الحالة',
            actions: 'اجراءات'
          }
        },
        manage_role: {
          tab_title: 'إدارة الأدوار',
          form: {
            fields: {
              roles: {
                title: 'الأدوار',
                placeholder: 'حدد الأدوار'
              },
              role_permissions: {
                title: 'التصريحات المفعلة',
                placeholder: 'سيتم عرض تصريحات الأدوار المحددة هنا.'
              },
              permissions: {
                title: 'التصريحات',
                placeholder: 'خدد تصريحات المستخدم'
              }
            }
          },
          buttons: {
            roles: {
              text: 'إضافة أو إزالة التصريحات المحددة من الأدوار المحددة',
              add_button: 'اضافة',
              remove_button: 'إزالة'
            },
            permissions: {
              text: 'إضافة أو إزالة التصريحات المحددة من المستخدمين المختارين',
              add_button: 'اضافة',
              remove_button: 'إزالة'
            }
          }
        }
      }
    },
    form: {
      create_user_btn: 'إنشاء مستخدم جديد',
      toggle_form: 'انقر هنا لإنشاء مستخدم.',
      the_user_level_is: 'مستوى المستخدم هو {level}',
      create_user: {
        title: 'إنشاء المستخدم',
        subtitle: 'إنشاء مستخدم جديد'
      },
      update_user: {
        title: 'حفظ المستخدم',
        subtitle: 'حفظ المستخدم'
      },
      fields: {
        full_name: {
          title: 'الاسم الكامل',
          placeholder: 'اكتب الاسم الكامل'
        },
        user_name: {
          title: 'اسم المستخدم',
          placeholder: 'اكتب اسم المستخدم'
        },
        email: {
          title: 'البريد الالكتروني',
          placeholder: 'example@example.com'
        },
        password: {
          title: 'كلمه المرور',
          placeholder: 'اكتب كلمة المرور'
        },
        confirmation: {
          title: 'تأكيد كلمة المرور',
          placeholder: 'أكتب تأكيد كلمة المرور'
        },
        phone: {
          title: 'الهاتف',
          placeholder: 'أكتب رقم الهاتف'
        },
        skype: {
          title: 'سكايب',
          placeholder: 'اكتب معرف سكايب'
        },
        company: {
          title: 'الشركة',
          placeholder: 'اكتب اسم الشركة'
        },
        country: {
          title: 'الدولة',
          all_option: 'حدد البلد',
          placeholder: 'اكتب اسم الدولة'
        },
        role: {
          title: 'الدور',
          placeholder: 'حدد دور المستخدم'
        },
        permission: {
          title: 'التصريحات',
          hint: 'حدد التصريحات بحظر',
          placeholder: 'حدد تصريحات المستخدم'
        },
        status: {
          title: 'الحالة'
        },
        seller_status: {
          title: 'حالة البائع'
        },
        level: {
          title: 'المستوى',
          placeholder: 'حدد مستوى المستخدم'
        },
        subscribed_to_news_letter: {
          title: 'اشترك في النشرة الإخبارية'
        }
      },
      buttons: {
        create: 'إنشاء المستخدم',
        save: 'حفظ المستخدم',
        duplicate: 'نسخ المستخدم',
        cancel: 'الغاء'
      }
    }
  },
  account_settings: {
    email_not_verified: {
      text: 'لم يتم التحقق من بريدك الإلكتروني حتى الآن ، انقر فوق الزر لإرسال طلب تحقق جديد.',
      button: 'تحقق'
    }
  },
  library_page: {
    images: 'الصور',
    videos: 'أشرطة فيديو',
    dialog: {
      title: 'حذف الصورة',
      content: 'هل أنت متأكد أنك تريد حذف هذه الصورة؟'
    }
  },
  notifications: {
    notifications: 'إشعارات',
    view_notifications: 'عرض الاشعارات',
    no_notification_found: 'لم يتم العثور على أي إشعارات.'
  },
  invoice_statuses: {
    [Invoice.PAID_STATUS]: 'دفع',
    [Invoice.PENDING_STATUS]: 'في الانتظار',
    [Invoice.NOT_APPLICABLE_STATUS]: 'غير متاح'
  },
  user_statuses: {
    [User.ACTIVE_STATUS]: 'نشيط',
    [User.INACTIVE_STATUS]: 'غير نشيط',
    [User.SUSPENDED_STATUS]: 'موقوف'
  },
  role: {
    [Role.WAREHOUSE_ROLE]: 'مستودع',
    [Role.INFLUENCER_ROLE]: 'مؤثر',
    [Role.SELLER_ROLE]: 'بائع',
    [Role.AFFILIATE_ROLE]: 'مسوق',
    [Role.ADMIN_ROLE]: 'مشرف',
    [Role.MANAGER_ROLE]: 'مدير',
    [Role.CALL_AGENT_ROLE]: 'وكيل الاتصال',
    [Role.ADVERTISER_ROLE]: 'معلن'
  },
  seller_statuses: {
    [User.STANDARD_SELLER_STATUS]: 'عادي',
    [User.EXCLUSIVE_SELLER_STATUS]: 'حصري',
    [User.PRIVATE_SELLER_STATUS]: 'خاص',
    [User.TEST_SELLER_STATUS]: 'تجريبي'
  },
  product_statuses: {
    [Product.ACTIVE_STATUS]: 'نشيط',
    [Product.DRAFT_STATUS]: 'المسودة'
  },
  advertiser_types: {
    [User.HYBRID_ADVERTISER_TYPE]: 'شبه مستقل',
    [User.INDEPENDENT_ADVERTISER_TYPE]: 'مستقل',
    [User.SOLO_ADVERTISER_TYPE]: 'منفرد'
  },
  inventory_types: {
    [Inventory.PRIVATE_TYPE]: 'خاص',
    [Inventory.OUTSOURCED_TYPE]: 'خارجي'
  },
  ticket_statuses: {
    [Ticket.CLOSED_STATUS]: 'أغلقت',
    [Ticket.CREATED_STATUS]: 'أنشأت',
    [Ticket.UPDATED_STATUS]: 'أحدثت'
  },
  referred_from: {
    [User.REFERRED_FROM_YOUTUBE]: 'يوتيوب',
    [User.REFERRED_FROM_FACEBOOK]: 'فيسبوك',
    [User.REFERRED_FROM_INSTAGRAM]: 'انستغرام',
    [User.REFERRED_FROM_GOOGLE]: 'جوجل',
    [User.REFERRED_FROM_FRIEND]: 'صديق',
    [User.REFERRED_FROM_OTHER]: 'أماكن أخرى'
  },
  sale_page_default_currency_type: {
    [SalePage.OFFER_COUNTRY_DEFAULT_CURRENCY]: 'عملة دولة المخزون',
    [SalePage.CUSTOM_CURRENCY]: 'عملة إختيارية'
  },
  stripe_modes: {
    [Stripe.TEST_MODE]: 'إختباري',
    [Stripe.LIVE_MODE]: 'حقيقي'
  },
  invoice_types: {
    [Invoice.EXPENSES_TYPE]: 'المصاريف',
    [Invoice.CHARGES_TYPE]: 'اليداعات'
  },
  offer_country_select_types: {
    [Offer.MULTIPLE_COUNTRY_SELECT_TYPE]: 'عدة دول',
    [Offer.SAME_COUNTRY_SELECT_TYPE]: 'نفس الدولة',
    [Offer.WORLD_WIDE_COUNTRY_SELECT_TYPE]: 'جميع أنحاء العالم'
  },
  store_language_types: {
    [Store.ONE_LANGUAGE_TYPE]: 'لغة واحدة',
    [Store.MULTIPLE_LANGUAGE_TYPE]: 'لغات متعددة'
  },
  ticket_types: {
    [Ticket.FEATURE_REQUEST_TYPE]: 'مشكلة فنية',
    [Ticket.HOW_TO_TYPE]: 'كيف تعمل',
    [Ticket.PAYMENT_TYPE]: 'الدفع',
    [Ticket.TECHNICAL_PROBLEM_TYPE]: 'طلب خاصية'
  },
  offer_payment_types: {
    [Offer.COD_PAYMENT_TYPE]: 'نقدا عند التسليم',
    [Offer.CARD_PAYMENT_TYPE]: 'بالبطاقة البنكية',
    [Offer.CARD_PAYMENT_TYPE_ALTERNATIVE]: 'مسبق الدفع'
  },
  checkout_form_setting_methods: {
    [CheckoutFormSettings.COD_PAYMENT_METHOD]: 'نقدا عند التسليم',
    [CheckoutFormSettings.CARD_PAYMENT_METHOD]: 'بالبطاقة البنكية'
  },
  offer_statuses: {
    [Offer.ACTIVE_STATUS]: 'نشيط',
    [Offer.DRAFT_STATUS]: 'المسودة',
    [Offer.PAUSED_STATUS]: 'متوقف'
  },
  offer_commission_type: {
    [Offer.CONFIRMED_COMMISSION_TYPE]: 'عند التأكيد',
    [Offer.DELIVERED_COMMISSION_TYPE]: 'عند التسليم'
  },
  sale_page_statuses: {
    [SalePage.ACTIVE_STATUS]: 'نشيط',
    [SalePage.DRAFT_STATUS]: 'المسودة',
    [SalePage.PAUSED_STATUS]: 'متوقف'
  },
  order_google_sheet_orders_from: {
    [GoogleSheet.FROM_ANY_WHERE]: 'من أي مكان',
    [GoogleSheet.FROM_PRODUCT]: 'من منتج',
    [GoogleSheet.FROM_WAREHOUSE]: 'من مستودع',
    [GoogleSheet.FROM_SALE_PAGE]: 'من صفحة البيع',
    [GoogleSheet.FROM_STORE]: 'من متجر'
  },
  ecommerce_sdk_account_statuses: {
    [ECommerceSdkAccount.ACTIVE_STATUS]: 'نشيط',
    [ECommerceSdkAccount.INACTIVE_STATUS]: 'غير نشط'
  },
  pre_sell_page_statuses: {
    [PreSellPage.ACTIVE_STATUS]: 'نشيط',
    [PreSellPage.INACTIVE_STATUS]: 'غير نشيط'
  },
  product_variation_statuses: {
    [ProductVariation.ACTIVE_STATUS]: 'نشيط',
    [ProductVariation.INACTIVE_STATUS]: 'غير نشيط'
  },
  offer_types: {
    [Offer.STANDARD_TYPE]: 'عادي',
    [Offer.EXCLUSIVE_TYPE]: 'حصري',
    [Offer.VIP_TYPE]: 'ممتاز',
    [Offer.TEST_TYPE]: 'اختبار',
    [Offer.PRIVATE_TYPE]: 'خاص'
  },
  order_call_statuses: {
    [Order.NEW_CALL_STATUS]: 'جديد',
    [Order.CALL_STATUS]: {
      1: 'المكالمة 1',
      2: 'المكالمة 2',
      3: 'المكالمة 3',
      4: 'المكالمة 4',
      5: 'المكالمة 5',
      6: 'المكالمة 6',
      7: 'المكالمة 7',
      8: 'المكالمة 8',
      9: 'المكالمة 9',
      10: 'المكالمة 10',
      11: '1المكالمة 1',
      12: 'المكالمة 12',
      13: 'المكالمة 13',
      14: 'المكالمة 14',
      15: 'المكالمة 15'
    },
    [Order.WRONG_NUMBER_STATUS]: 'الرقم خاطئ',
    [Order.NO_REPLY_STATUS]: 'لا يوجد رد',
    [Order.EXPIRED_STATUS]: 'منتهي الصلاحية',
    [Order.SCHEDULED_STATUS]: 'محدد الموعد',
    [Order.WRONG_COUNTRY_STATUS]: 'خطئ في الدولة'
  },
  offer_levels: {
    auto: 'تلقائي',
    level_1: 'المستوى 1',
    level_2: 'المستوى 2',
    level_3: 'المستوى 3',
    vip: 'المستوى الممتاز'
  },
  sale_page_option_type: {
    [Option.NORMAL_OFFER_TYPE]: 'عادي',
    [Option.WARNING_OFFER_TYPE]: 'ضمان'
  },
  subscription_plans: {
    [SubscriptionPlan.BASIC_PLAN_NAME]: 'إشتراك عادي',
    [SubscriptionPlan.ADVANCED_PLAN_NAME]: 'إشتراك متقدم',
    [SubscriptionPlan.BUSINESS_PLAN_NAME]: 'إشتراك شركة',
    [SubscriptionPlan.FULL_ACCESS_PLAN_NAME]: 'إشتراك كامل'
  },
  order_statuses: {
    all: 'الكل',
    [Order.RETURNED_STATUS]: 'مرجعة',
    [Order.DELIVERED_STATUS]: 'مسلمة',
    [Order.SHIPPED_STATUS]: 'مشحنة',
    [Order.CANCELED_STATUS]: 'ملغات',
    [Order.CONFIRMED_STATUS]: 'مؤكدة',
    [Order.PROCESSING_STATUS]: 'معالجة',
    [Order.PENDING_STATUS]: 'في الانتظار',
    [Order.NO_ANSWER_STATUS]: 'لا استجابة'
  },
  insert_orders_from: {
    [GoogleSheet.FROM_ANY_WHERE]: 'من أي طلب في حسابي',
    [GoogleSheet.FROM_STORE]: 'من المتجر',
    [GoogleSheet.FROM_PRODUCT]: 'من المنتج',
    [GoogleSheet.FROM_WAREHOUSE]: 'من المستودع',
    [GoogleSheet.FROM_SALE_PAGE]: 'من صفحة البيع'
  },
  notification_types: {
    [Notification.FEATURE_TYPE]: 'ميزة',
    [Notification.INVOICE_TYPE]: 'فاتورة',
    [Notification.OFFER_TYPE]: 'عرض',
    [Notification.PRODUCT_TYPE]: 'منتج',
    [Notification.SUPPORT_TYPE]: 'دعم',
    [Notification.OTHER_TYPE]: 'آخر'
  },
  store_page: {
    languages: {
      [StorePage.ARABIC_LANG_SHORT]: 'العربية',
      [StorePage.ENGLISH_LANG_SHORT]: 'الإنجليزية',
      [StorePage.FRENCH_LANG_SHORT]: 'الفرنسية',
      [StorePage.ITALY_LANG_SHORT]: 'الإيطالية',
      [StorePage.SPANISH_LANG_SHORT]: 'الإسبانية'
    },
    types: {
      [StorePage.HOME_PAGE]: 'الصفحة الرئيسية',
      [StorePage.FAQ_PAGE]: 'صفحة الأسئلة المتداولة',
      [StorePage.CONTACT_PAGE]: 'الإتصال',
      [StorePage.PRODUCT_PAGE]: 'صفحة المنتجات',
      [StorePage.ABOUT_PAGE]: 'صفحة معلومات عنا',
      [StorePage.SHIPPING_AND_RETURN_PAGE]: 'صفحة الشحن والارجاع',
      [StorePage.SERVICE_TERMS_PAGE]: 'صفحة شروط الخدمة',
      [StorePage.PRIVACY_POLICY_PAGE]: 'صفحة سياسة الخصوصية',
      [StorePage.REFUND_POLICY_PAGE]: 'صفحةالإسترداد'
    }
  },
  sale_page_checkout_length: {
    [SalePage.SHORT_CHECKOUT]: 'استمارة قصيرة',
    [SalePage.LONG_CHECKOUT]: 'استمارة طويلة',
    [SalePage.CUSTOM_CHECKOUT]: 'استمارة خاصة'
  },
  domain_types: {
    [Store.GENERAL_TYPE]: 'عام',
    [Store.BRAND_TYPE]: 'علامة تجارية'
  },
  sale_page_block_types: {
    main: 'طاهر في الصفحة',
    home: 'الرئيسية',
    cross_sell_1: 'بيع الملحقات 1'
  },
  sale_page_block_images_alignment: {
    left: 'اليسار',
    right: 'اليمين',
    center: 'الوسط'
  },
  languages: {
    ar: 'عربي',
    en: 'إنجليزي',
    es: 'إسباني',
    fr: 'فرنسي',
    it: 'إيطاليي'
  },
  generic_text: {
    ticket_notification_title: 'رسالة دعم جديدة',
    ticket_notification_description: '</a>لديكم رسالة دعم جديدة, المرجوا تصفحها <a class="font-weight-bold" href="/support">هنا</a>'
  },
  form: {
    here: 'هنا',
    login: {
      user_name_or_email: 'البريد الالكتروني',
      user_password: 'كلمة مرور المستخدم',
      login: 'تسجيل الدخول',
      forget_password: 'هل نسيت كلمة السر ؟ أطلبها',
      dont_have_account: 'ليس لديك حساب؟ اشترك'
    },
    password_request: {
      user_email: 'البريد الالكتروني للمستخدم',
      back_to_login: 'العودة إلى تسجيل الدخول',
      request_new_password: 'طلب كلمة مرور جديدة'
    },
    register: {
      sign_up_as_affiliate: 'التسجيل كمسوق أو مؤثر؟ الرجاء تحديد:',
      before_sign_up_text: 'حدد خطة وأضف معلوماتك لإنشاء متجرك عبر الإنترنت.',
      agree_to_terms_and_services: {
        part_one: 'أوافق على',
        part_two: 'شروط الخدمة',
        part_three: 'و',
        part_four: 'سياسة الخصوصية'
      },
      receive_email_news_letters: 'تلقي رسائل البريد الإلكتروني حول العروض الجديدة والتحديثات',
      do_you_have_account: 'لديك حساب؟ تسجيل الدخول',
      sign_up: 'إفتح حساب',
      user_social_media_profile: {
        title: 'Instagram أو Tiktok أو snapchat',
        placeholder: 'رابط / اسم وسائل التواصل الاجتماعي'
      },
      user_type: {
        options: {
          [Role.SELLER_ROLE]: 'مسوق (Affiliate)',
          [Role.INFLUENCER_ROLE]: 'مؤثر (Influencer)'
        }
      },
      user_youtube_channel: {
        title: 'قناة يوتيوب',
        placeholder: 'رابط قناة يوتيوب'
      },
      subscription_plan: {
        title: 'خطة الإشتراك',
        options: {
          [SubscriptionPlan.BASIC_PLAN_NAME]: 'إشتراك عادي',
          [SubscriptionPlan.ADVANCED_PLAN_NAME]: 'إشتراك متقدم',
          [SubscriptionPlan.BUSINESS_PLAN_NAME]: 'إشتراك شركة',
          [SubscriptionPlan.FULL_ACCESS_PLAN_NAME]: 'إشتراك كامل',
          [SubscriptionPlan.BASIC_PLAN_NAME]: {
            text: 'إشتراك عادي',
            price: '<span>0 دولار/شهر</span> &nbsp; <span style="text-decoration: line-through; font-size: 12px; color: grey">19.99 دولار/شهر</span>',
            features: {
              title: 'المميزات',
              content: ['متجر واحد', 'منتجات غير محدودة', 'صفحات بيع غير محدودة', 'طلبات غير محدودة', '0% مصاريف المعاملات', 'إحصائيات عادية', 'تطبيقات عادية', 'دعم عادي', 'بدون أفراد طاقم', 'بدون ربط API خارجي', 'بدون دعم إنشاء المحتوى بال AI']
            }
          },
          [SubscriptionPlan.ADVANCED_PLAN_NAME]: {
            text: 'إشتراك متقدم',
            price: '<span>9.99 دولار/شهر</span> &nbsp; <span style="text-decoration: line-through; font-size: 12px; color: grey">29.99 دولار/شهر</span>',
            features: {
              title: 'المميزات',
              content: ['متجران', 'منتجات غير محدودة', 'صفحات بيع غير محدودة', 'طلبات غير محدودة', '0% مصاريف المعاملات', 'إحصائيات متقدمة', 'تطبيقات متقدمة', 'دعم شات', 'أفراد طاقم (2)', 'ربط API خارجي', 'دعم إنشاء المحتوى بال AI']
            }
          },
          [SubscriptionPlan.BUSINESS_PLAN_NAME]: {
            text: 'إشتراك شركة',
            price: '<span>49.99 دولار/شهر</span> &nbsp; <span style="text-decoration: line-through; font-size: 12px; color: grey">99.99 دولار/شهر</span>',
            features: {
              title: 'المميزات',
              content: ['عشر متاجر', 'منتجات غير محدودة', 'صفحات بيع غير محدودة', 'طلبات غير محدودة', '0% مصاريف المعاملات', 'إحصائيات متقدمة', 'تطبيقات متقدمة', 'دعم شات و الهاتف', 'أفراد طاقم (20)', 'ربط API خارجي', 'دعم إنشاء المحتوى بال AI محترف']
            }
          }
        }
      },
      user_name: {
        title: 'إسم المستخدم (حروف إنجليزية فقط)',
        placeholder: 'اسم المستخدم'
      },
      store_name: {
        title: 'إسم المتجر',
        placeholder: 'mystore',
        hint: 'مسموح فقط بالأحرف الإنجليزية والأرقام و-.'
      },
      store_language: {
        title: 'لغة المتجر',
        options: {
          en: 'الإنجليزية',
          ar: 'العربية',
          it: 'الإيطالية',
          fr: 'الفرنسية',
          es: 'الإسبانية'
        }
      },
      user_full_name: {
        title: 'الاسم الكامل',
        placeholder: 'الاسم الكامل'
      },
      user_country: {
        title: 'الدولة',
        placeholder: 'حدد الدولة'
      },
      user_email: {
        title: 'البريد الالكتروني',
        placeholder: 'عنوان بريد الكتروني'
      },
      user_password: {
        title: 'كلمه المرور',
        placeholder: 'كلمه المرور'
      },
      user_password_confirmation: {
        title: 'تأكيد كلمة المرور',
        placeholder: 'اعد كلمة السر'
      },
      user_presentation: {
        title: 'أين سمعت عنا؟',
        placeholder: 'أخبرنا أين سمعت عن متاجر ماكسكوم؟',
        options: {
          default_option: 'حدد المكان الذي سمعت فيه عنا'
        }
      }
    },
    password_reset: {
      reset_new_password: 'إعادة تعيين كلمة المرور الجديدة',
      back_to_login: 'العودة إلى تسجيل الدخول',
      request_password: {
        title: 'كلمة المرور الجديدة',
        placeholder: 'كلمة المرور الجديدة'
      },
      request_password_repeat: {
        title: 'تأكيد كلمة السر الجديدة',
        placeholder: 'تأكيد كلمة السر الجديدة'
      }
    }
  },
  components: {
    from_to_component: {
      from: 'من',
      to: 'إلى',
      days: 'أيام'
    },
    side_bar_item: {
      tooltip: {
        upgrade_plan: 'قم بترقية حسابك لتفعيل هذه الميزة القوية وتنمية متجرك بسرعة.'
      }
    },
    ai_content_generator: {
      title: 'إنشاء المحتوى',
      form: {
        fields: {
          model_name: {
            title: 'إسم نموذج ChatGpt',
            placeholder: 'حدد إسم النموذج'
          },
          product_title: {
            title: 'عنوان المنتج',
            we_will_use: 'سوف نستخدم هذه المعلومات لإنشاء نص صفحة البيع، ويمكنك تصحيحه أو تحسينه قبل أن نبدأ.',
            placeholder: 'أكتب النسخة المفضلة لديك من إسم المنتج'
          },
          product_description: {
            title: 'وصف المنتج',
            placeholder: 'أوصف المنتج هنا'
          },
          country: {
            title: 'الدولة',
            placeholder: 'أكتب اسم البلد'
          },
          language: {
            title: 'اللغة'
          },
          gender_options: {
            men: 'رجال',
            women: 'نساء',
            men_and_women: 'رجال ونساء'
          },
          buttons: {
            generate_content: 'أنشئ المحتوى'
          }
        }
      },
      update_content_fields: {
        title: 'تعديل النص',
        fields: {
          content: {
            title: 'عنوان',
            placeholder: 'أضف نصا هنا'
          }
        },
        buttons: {
          save: 'حفظ',
          cancel: 'إلغاء'
        }
      },
      update_content_generated: {
        title: 'عرض المحتوى المُنشأ',
        wait: 'قد يستغرق هذا بعض الوقت، يرجى الانتظار...',
        sorry: 'عذراً! لقد واجهنا مشكلة، يرجى المحاولة مرة أخرى.',
        edit_field: {
          title: 'تحديث المحتوى',
          fields: {
            content: {
              title: 'عنوان',
              placeholder: 'أضف نصا هنا'
            }
          },
          buttons: {
            update: 'تحديث المحتوى',
            cancel: 'إلغاء'
          }
        },
        buttons: {
          add: 'أضف إلى الصفحة',
          update: 'التحديث بالذكاء الاصطناعي',
          cancel: 'إلغاء'
        }
      }
    },
    edit_columns: {
      title: 'تعديل الخانات',
      reset: 'إعادة الضبط'
    },
    subscription_dialog: {
      title: 'خطة الإ شتراك',
      you_are_in: 'أنت الان في',
      upgrade: 'ترقية الإشتراك',
      button: {
        current_plan: 'خطة الإ شتراك الحالية',
        upgrade_plan: 'الترقية إلى {plan}',
        downgrade_plan: 'الرجوع إلى {plan}',
        next_plan: 'الخطة القادمة',
        error: 'خطأ'
      },
      price: '{price}/شهر',
      plans: {
        [SubscriptionPlan.BASIC_PLAN_NAME]: {
          title: 'خطة عادية',
          features: ['متجر واحد، دومين واحد', 'رابط API واحد خارجي', 'دعم إنشاء المحتوى 10 مرات بال AI', 'منتجات غير محدودة', 'صفحات بيع غير محدودة', 'طلبات غير محدودة', '0% مصاريف المعاملات', 'إحصائيات عادية', 'تطبيقات عادية', 'دعم عادي', 'بدون أفراد طاقم']
        },
        [SubscriptionPlan.ADVANCED_PLAN_NAME]: {
          title: 'خطة متقدمة',
          features: ['متجران، دومينان', 'رابط API خارجي غير محدود', 'دعم إنشاء المحتوى بال AI غير محدود', 'منتجات غير محدودة', 'صفحات بيع غير محدودة', 'طلبات غير محدودة', '0% مصاريف المعاملات', 'إحصائيات متقدمة', 'تطبيقات متقدمة', 'دعم شات', 'أفراد طاقم (2)']
        },
        [SubscriptionPlan.BUSINESS_PLAN_NAME]: {
          title: 'خطة شركة',
          features: ['عشر متاجر، عشر دومينات', 'رابط API خارجي غير محدود', 'دعم إنشاء محتوى محترف بال AI غير محدود', 'منتجات غير محدودة', 'صفحات بيع غير محدودة', 'طلبات غير محدودة', '0% مصاريف المعاملات', 'إحصائيات متقدمة', 'تطبيقات متقدمة', 'دعم شات و الهاتف', 'أفراد طاقم (20)']
        }
      }
    },
    import_orders: {
      title: 'إستيراد الطلبات',
      text: 'يرجى إدخال بيانات طلباتك، وبالنقر على خلية الجدول يمكنك إدخال قيمة.',
      table: {
        columns: {
          order_date: 'تاريخ الطلب',
          custom_id: 'معرف مخصص',
          full_name: 'الاسم الكامل',
          phone: 'الهاتف',
          country: 'البلد',
          address: 'العنوان',
          sale_page: 'صفحة البيع',
          quantity: 'الكمية'
        }
      },
      notes: {
        title: 'ملاحظات',
        bullets: {
          one: 'في عمود صفحة البيع، يجب لصق المعرف، أو اختيار صفحة بيع من القائمة.',
          two: 'في عمود البلد، يجب لصق إسم البلد.',
          three: 'المعرف المخصص اختياري، يمكنك إضافته لتعريف الطلباتك الخاصة بك.'
        }
      },
      validationDialog: {
        title: 'أخطاء التحقق من الصحة',
        text: 'يرجى التحقق من تعليق الخلية للحصول على تلميحات حول التحقق من صحة البيانات.',
        dont_show_again: 'فهمت، لا تريني هذه النافذة مرة أخرى.',
        actions: {
          close: 'إغلاق'
        }
      },
      actions: {
        upload: 'رفع الطلبات'
      }
    },
    live_chat_widget_addon: {
      form: {
        alert: {
          accountIdInfo: 'يمكنك الحصول على  <span style="font-weight: bold">معرف الخاصية</span> الخاص بك من <span style="font-weight: bold">Administration > Overview</span>',
          widgetIdInfo: 'يمكنك الحصول على <span style="font-weight: bold">معرف الواجهة</span> الخاص بك من <span style="font-weight: bold">Administration > Channels > Chat Widget</span>'
        },
        fields: {
          is_enabled: {
            title: 'الدردشة الحية مع Tawk.to'
          },
          account_id: {
            title: 'معرف الخاصية',
            placeholder: '12fg896gfrtvr15rgr21r'
          },
          widget_id: {
            title: 'معرف الواجهة',
            placeholder: '58fg54515rf'
          }
        }
      }
    },
    option_form: {
      option_name: {
        title: '',
        translation: {
          option_1: 'قطعة واحدة',
          option_2: 'قطعتين',
          option_3: '3 قطع',
          option_4: '4 قطع',
          option_5: '5 قطع'
        }
      },
      discount: {
        title: 'نص الخصم (اختياري)',
        placeholder: 'تخفيض'
      },
      normal_price: {
        title: 'السعر القديم (اختياري)'
      },
      sale_price: {
        title: 'سعر البيع'
      }
    },
    offer_option_form: {
      offer_name: {
        title: 'إسم العرض',
        content: {
          x_product: '{x}x إسم المنتج',
          buy_get_free: 'إشتري {buy} للحصول على {free} مجانا'
        },
        placeholder: 'إسم العرض'
      },
      discount: {
        content: '{{dis}} تخفيص - {{up}}/الوحدة'
      }
    },
    upsell_option_form: {
      offer_name: {
        placeholder: 'إسم العرض',
        content: {
          upsell_1: 'اسم العرض -50% خصم',
          upsell_2: 'اسم العرض',
          upsell_3: 'إضافة ضمان لمدة سنة واحدة فقط مقابل ؟'
        }
      },
      offer_nick_name: {
        placeholder: 'لقب العرض'
      },
      discount: {
        content: {
          normal: '{{dis}}',
          warranty: 'ضمان لمدة عام واحد لعنصر واحد'
        }
      }
    },
    cross_sell_option_form: {
      product_id: {
        placeholder: 'إختر عرضا'
      },
      product_nick_name: {
        placeholder: 'لقب العرض'
      },
      discount: {
        content: {
          normal: '{{dis}}',
          warranty: 'ضمان لمدة عام واحد لعنصر واحد'
        }
      }
    },
    sale_page_allowed_countries_component: {
      is_enabled: {
        title: 'إجعل صفحة البيع تظهر حسب الدولة'
      },
      country_select_type: {
        title: 'نوع الإجراء',
        options: {
          [AllowedCountriesAddon.WHITE_LIST_TYPE]: 'القائمة البيضاء',
          [AllowedCountriesAddon.BLACK_LIST_TYPE]: 'القائمة السوداء'
        }
      },
      country_select: {
        title: 'قائمة الدول',
        hint: 'المرجوا اختيار دولة أو عدة دول',
        placeholder: 'اختر الدول التي يمكنها رؤية هذه الصفحة',
        info: 'يمكنك اختيار الدول التي تريد استهدافها، وسيتم إيحال جميع الزائرين الغير مستهدفة دولهم إلى الصفحة الرئيسية.'
      }
    },
    identity_verification_setting: {
      title: 'التحقق من الهوية',
      subtitle: 'التحقق من الهوية',
      verification_rejection_message: 'تم رفض التحقق الخاص بك.',
      verification_success_message: 'تم التحقق من حسابك.',
      form: {
        fields: {
          full_name: {
            title: 'الإسم الكامل',
            placeholder: 'أكتب اسمك الكامل'
          },
          id_front_image: {
            title: 'الصورة الأمامية لبطاقة التعريف'
          },
          id_back_image: {
            title: 'الصورة الخلفية لبطاقة التعريف'
          },
          accept_terms_and_conditions: {
            title: {
              part_one: 'أوافق على',
              part_two: 'الأحكام والشروط.'
            }
          }
        },
        buttons: {
          title: 'حفظ التغييرات'
        }
      }
    },
    pixel_component: {
      no_pixel_added: 'لم يتم إضافة بكسل',
      pixel_title: 'إسم',
      conversion_event_name: 'حدث التحويل',
      form: {
        fields: {
          facebook: {
            title: 'تعريف البكسل',
            placeholder: 'تعريف البكسل',
            conversion_names: {
              [Pixel.CONVERSION_PURCHASE]: 'شراء',
              [Pixel.CONVERSION_LEAD]: 'عميل محتمل'
            }
          },
          snapchat: {
            title: 'تعريف البكسل',
            placeholder: 'تعريف البكسل'
          },
          twitter: {
            title: 'تعريف البكسل',
            placeholder: 'تعريف البكسل'
          },
          google: {
            title: 'معرف العلامة',
            placeholder: 'GTM-XXXXXX'
          },
          tiktok: {
            title: 'تعريف البكسل',
            placeholder: 'تعريف البكسل',
            conversion_names: {
              [Pixel.CONVERSION_COMPLETE_PAYMENT]: 'دفع مكتمل',
              [Pixel.CONVERSION_PLACE_AN_ORDER]: 'وضع الطلب'
            }
          },
          microsoft_clarity: {
            title: 'تعريف المشروع',
            placeholder: 'تعريف المشروع'
          },
          google_tag: {
            title: 'معرف العلامة',
            placeholder: 'G-XXXXXX OR AW-XXXXXX'
          },
          postback: {
            title: 'عنوان url لإعادة النشر',
            placeholder: 'https://your_postback_url?cid={cid}&payout={payout}'
          },
          token: {
            title: 'رمز API (إختياري)'
          }
        }
      }
    },
    woo_commerce: {
      title: 'قم بتوصيل WooCommerce الخاص بك',
      subtitle: 'قم بتحميل جميع طلباتك تلقائيًا إلى متجر Woocommerce الخاص بك! فقط قم بتوصيله وسوف نبقيه محدثًا بعروضك وطلباتك التي تم الترويج لها في الوقت المحدد',
      form: {
        fields: {
          domain_name: {
            title: 'اسم مجال WooCommerce الخاص بك:',
            placeholder: 'www.example.com'
          },
          sync_info: {
            title: 'احصل على معلومات الشحن الخاصة بالطلب من Woocommerce؟'
          }
        },
        buttons: {
          connect: 'الاتصال'
        }
      },
      table: {
        domain_name: 'المتجر المتصل',
        user_name: 'إسم المستخدم',
        status: 'الحالة',
        last_update: 'آخر تحديث',
        actions: 'تعديلات',
        enable_or_disable: 'إرسال الطلبات الى متجرك',
        get_status_by_domain: 'تحديث طلباتك من متجرك',
        tooltips: {
          connect: 'إتصل بمتجرك woocommerce',
          mapping: 'تعيين المنتجات: ربط منتجات woocommerce بالعروض',
          enable_or_disable: 'تشغيل/إيقاف إرسال الطلبات الى متجرك',
          delete_domain: 'محو متجرك من القائمة',
          get_status_by_domain: 'تحديث طلباتك من متجرك'
        }
      }
    },
    application_shopping: {
      title: 'قم بإنشاء خلاصات المنتجات لعروضك التي تم الترويج لها',
      subtitle: {
        [product_feed_types.FACEBOOK_FEED]: 'يمكنك هنا إعداد خلاصات منتجات "مدير التجارة" على Facebook وإنشائها لنطاقاتك والمنتجات التي تم الترويج لها.',
        [product_feed_types.GOOGLE_FEED]: 'هنا يمكنك إعداد وإنشاء خلاصات تسوق google للنطاقات والمنتجات التي تم الترويج لها.'
      },
      info: 'يجب أن تكون قد أنشأت بالفعل صفحة بيع لعرض من خلال اسم المجال الخاص بك لرؤية منتجها مدرج في الخلاصة التي تم إنشاؤها.',
      dialogs: {
        feed_products: {
          title: 'قائمة المنتجات على خلاصتك',
          beforeSubTitle: 'هنا يمكنك تعديل بعض معلومات المنتجات مثل الصورة والعنوان والوصف وصفحة البيع ، ويمكنك استبعاد المنتجات من الخلاصة.',
          subtitle: '<span style="color: red">ملاحظة:</span> يجب أن يكون عنوان المنتج ووصفه بنفس لغة صفحة البيع الخاصة بك ، إذا لم يكن كذلك ، فيرجى ترجمتهما قبل إرسال الخلاصة.',
          table: {
            product_id: 'معرف المنتج',
            product_image: 'الصورة الرئيسية',
            product_title: 'العنوان',
            product_description: 'وصف',
            product_brand: 'العلامة تجارية',
            product_sale_page: 'صفحة البيع',
            product_sale_price: 'سعر البيع',
            product_status: 'حالة'
          },
          buttons: {
            save: 'حفظ التغييرات'
          }
        },
        delete: {
          title: 'حذف الخلاصة',
          content: 'هل أنت متأكد أنك تريد حذف هذا الخلاصة؟'
        }
      },
      form: {
        site_verification_text: 'احصل على سلسلة التحقق من {application_name} من حساب {application_name} والصقها هنا للتحقق من ملكية اسم المجال الخاص بك في {application_name}. (انسخ رمز سلسلة التحقق فقط)',
        your_verification_string_here: 'سلسلة التحقق الخاصة بك هنا',
        fields: {
          domain: {
            title: 'نطاق',
            placeholder: ''
          },
          verification_string: {
            title: 'سلسلة التحقق من النطاق',
            before_text: 'حفظ سلسلة التحقق من النطاق',
            placeholder: ''
          },
          country: {
            title: 'البلد',
            before_text: 'ةاملأ هذه المعلومات لإنشاء خلاصة جديدة',
            placeholder: ''
          },
          feed_name: {
            title: 'إسم الخلاصة',
            placeholder: ''
          }
        }
      },
      buttons: {
        generate_feed: 'إنشاء الخلاصة'
      },
      table: {
        feed_id: 'تعريف الخلاصة',
        user: 'اسم المستخدم',
        domain: 'إسم النطاق',
        feed_name: 'إسم الخلاصة',
        target_country: 'البلد المستهدف',
        submitted_products: 'المنتجات المفعلة',
        actions: 'إجراءات'
      }
    },
    library: {
      images: 'الصور',
      videos: 'أشرطة فيديو',
      image_tab: {
        no_images_found: 'لم يتم العثور على أية صور.'
      },
      video_tab: {
        no_videos_found: 'لم يتم العثور على أية أشرطة فيديو.'
      }
    },
    chart: {
      chart_evolution_text: 'تطور الأرباح والتحويلات حسب الفترة المحددة',
      date: 'تاريخ',
      chart_colors: {
        earnings: 'الارباح'
      }
    },
    payment_processors: {
      title: 'معالجات الدفع',
      subtitle: 'معالجات الدفع',
      one_account_requirement_alert: 'يجب أن يكون حساب واحد على الأقل مفعل إلا ستفشل عمليات الدفع.',
      stripe_form: {
        fields: {
          name: {
            title: 'الإسم',
            placeholder: 'إسم الحساب'
          },
          live_secret_key: {
            title: 'المفتاح السري الحقيقي',
            placeholder: 'ps_live_ ...'
          },
          live_public_key: {
            title: 'المفتاح العلني الحقيقي',
            placeholder: 'pk_live_ ...'
          },
          test_secret_key: {
            title: 'المفتاح السري اللإختباري',
            placeholder: 'ps_test_ ...'
          },
          test_public_key: {
            title: 'المفتاح العلني اللإختباري',
            placeholder: 'pk_test_ ...'
          },
          wallet: {
            title: 'تفعيل المحفظات (قوقل باي ى ابل باي('
          }
        },
        buttons: {
          add_stripe: 'أضف مفتاح جديد',
          save: 'حفظ المفاتيح'
        }
      }
    },
    payment_information: {
      title: 'معلومات الدفع',
      subtitle: 'يمكنك الحصول على أموال مقابل الطلبات المؤهلة عن طريق Payoneer (بدون رسوم) أو عن طريق التحويل البنكي (رسوم من 5 إلى 15 دولارًا).<br><br>' + 'الحد الأدنى لمبلغ الدفع هو 50 دولارًا',
      please_select: 'يرجى تحديد طريقة الدفع المفضلة لديك',
      form: {
        fields: {
          bank_choice: {
            options: {
              bank_details: 'التحويل البنكي'
            }
          }
        }
      },
      bank_details: {
        title: 'تفاصيل البنك',
        subtitle: 'املأ تفاصيل البنك الخاص بك هنا',
        form: {
          fields: {
            beneficiary_name: {
              title: 'أسم المستفيد',
              placeholder: 'اكتب اسم المستفيد'
            },
            country: {
              title: 'بلد البنك',
              placeholder: 'حدد بلد البنك الخاص بك'
            },
            name: {
              title: 'اسم البنك',
              placeholder: 'اكتب اسم البنك الخاص بك'
            },
            account_number: {
              title: 'رقم حساب',
              placeholder: 'اكتب رقم حسابك'
            },
            swift_code: {
              title: 'رمز SWIFT',
              placeholder: 'اكتب رمز سويفت الخاص بك'
            },
            bank_address: {
              title: 'عنوان البنك',
              placeholder: 'اكتب عنوان البنك الخاص بك'
            }
          }
        }
      },
      payoneer: {
        title: 'Payoneer',
        subtitle: 'املأ تفاصيل Payoneer الخاصة بك هنا',
        form: {
          fields: {
            beneficiary_name: {
              title: 'أسم المستفيد',
              placeholder: 'اكتب اسم المستفيد'
            },
            payoneer: {
              title: 'البريد الالكتروني ل Payoneer',
              placeholder: 'اكتب Payoneer الخاص بك'
            }
          }
        }
      },
      buttons: {
        save: 'احفظ المعلومات'
      }
    },
    account_tracking: {
      tracking_by_pixels: {
        title: 'التتبع بالبكسل',
        subtitle: 'أضف معلومات التتبع الخاصة بك هنا. ما عليك سوى إضافة معرف البكسل ، وليس رمز البكسل. سيتم استخدام جميع معرفات البكسل التي تحفظها هنا في صفحات مبيعات العروض الخاصة بك ، إلا إذا قمت بتغييرها في قسم بكسل العرض.',
        form: {
          fields: {
            facebook: {
              title: 'معرف بكسل الفيسبوك',
              placeholder: 'معرف البكسل'
            },
            google: {
              title: 'معرف علامة جوجل',
              placeholder: 'GTM-XXXXXXX'
            },
            snapchat: {
              title: 'معرف بكسل سناب شات',
              placeholder: 'معرف البكسل'
            },
            twitter: {
              title: 'معرف بكسل تويتر',
              placeholder: 'معرف البكسل'
            },
            tiktok: {
              title: 'معرف بكسل تيكتوك',
              placeholder: 'معرف البكسل'
            }
          }
        }
      },
      tracking_by_postback_url: {
        title: 'التتبع عن طريق عنوان URL لإعادة النشر',
        subtitle: 'يمكننا رد معرف النقر والعمولة إلى عنوان url الخاص بك لإعادة النشر، تأكد من تضمين هذه الرموز المميزة في عنوانك : {cid} لمعرف النقرة ، و {payout} لعمولة العرض.',
        subtitle2: 'مثال:',
        form: {
          fields: {
            postback_url: {
              title: 'عنوان url لإعادة النشر',
              placeholder: 'https://example.com'
            }
          }
        }
      },
      buttons: {
        save: 'احفظ المعلومات'
      }
    },
    account_settings: {
      title: 'إعدادات الحساب',
      subtitle: 'تغيير المعلومات الشخصية لك هنا.',
      form: {
        fields: {
          full_name: {
            title: 'الاسم الكامل',
            placeholder: 'اكتب اسمك الكامل'
          },
          company: {
            title: 'اسم الشركة',
            placeholder: 'اكتب الخاص بك'
          },
          country: {
            title: 'اسم الدولة',
            placeholder: 'حدد اسم بلدك'
          },
          username: {
            title: 'اسم المستخدم',
            placeholder: 'اكتب اسم المستخدم الخاص بك'
          },
          email: {
            title: 'البريد الالكتروني',
            placeholder: 'اكتب البريد الالكتروني الخاص بك'
          },
          phone: {
            title: 'رقم الهاتف',
            placeholder: 'اكتب رقم الهاتف الخاص بك'
          },
          old_password: {
            title: 'كلمة المرور القديمة',
            placeholder: 'اكتب  كلمة المرور القديمةالخاص بك'
          },
          skype: {
            title: 'سكايب',
            placeholder: 'اكتب معرف سكايب الخاص بك'
          },
          new_password: {
            title: 'كلمة المرور الجديدة',
            placeholder: 'اكتب كلمة المرور الجديدة الخاص بك'
          },
          confirmed_password: {
            title: 'تأكيد كلمة المرور',
            placeholder: 'أكيد كلمة المرور الخاص بك'
          },
          news_letter: {
            title: 'اشترك في نشرتنا الإخبارية.'
          },
          send_order_email: {
            title: 'أرسل لي رسالة بالبريد الإلكتروني بشأن الطلبات القادمة الجديدة.'
          }
        },
        buttons: {
          save: 'حفظ الحساب'
        }
      }
    },
    tracking: {
      pixel_type: {
        [Pixel.FACEBOOK]: startCase(Pixel.FACEBOOK),
        [Pixel.GOOGLE]: 'Google Tag Manager',
        [Pixel.SNAPCHAT]: startCase(Pixel.SNAPCHAT),
        [Pixel.TIKTOK]: startCase(Pixel.TIKTOK),
        [Pixel.TWITTER]: startCase(Pixel.TWITTER),
        [Pixel.POSTBACK]: startCase(Pixel.POSTBACK),
        [Pixel.MICROSOFT_CLARITY]: 'Google Analytics'
      }
    },
    domain_names: {
      create_domain: 'إضافة دومين',
      create_new_domain: 'إضافة ضومين جديد',
      update_domain: 'تعديل دومين',
      title: 'أسماء الدومينات (إسم دومين الموقع)',
      subtitle: 'اتبع الخطوات أدناه لتهيئة الدومين الخاص بك',
      type: 'النوع:',
      name_host: 'الاسم / المضيف:',
      ip_address: 'عنوان IP:',
      filter: {
        search: {
          title: 'بحث',
          placeholder: 'البحث عن طريق اسم الدومين'
        }
      },
      domain_types_desc: {
        [Store.GENERAL_TYPE]: 'متجر عام (للعديد من العروض)',
        [Store.COUNTRY_TYPE]: 'متجر البلد (لبلد واحد)',
        [Store.BRAND_TYPE]: 'علامة تجارية (لعرض واحد)'
      },
      table: {
        user_name: 'اسم المستخدم',
        domain: 'الدومين',
        payment_wallet: 'دفع محفظات الجيب',
        ssl: 'SSL',
        dns: 'DNS',
        logo: 'الشعار (400 × 80 بكسل)',
        email: 'البريد الالكتروني',
        store: 'عنوان المتجر',
        favicon: 'الأيقونة المفضلة (32 × 32 بكسل)',
        actions: 'أجراءات'
      },
      form: {
        step_one: {
          title: 'الخطوة 1:',
          subtitle: 'إضافة دومين جديد.'
        },
        step_two: {
          title: 'الخطوة 2: (في لوحة معلومات مسجل الموقع الخاص بك)',
          subtitle: 'انتقل إلى إعدادات DNS لالدومين (Domain DNS settings) الخاص بك ، وقم بإضافة أو تغيير عنوان A record إلى عنوان IP للسيرفر الخاص بنا:',
          add_cname: '<span style="text-align: start"><strong>اختياري:</strong> (باسم دومينك yourdomain.com استبدل) www. مثل هذا لتمكين الوصول إلى متجرك من خلال CNAME يمكنك إضافة سجل</span>'
        },
        step_three: {
          title: 'الخطوة 3:',
          subtitle: 'انتظر حتى تكون حالة DNS و SSL جاهزة قبل البدء في استخدام الدومين الخاص بك.'
        },
        fields: {
          type: {
            step: 'كيف ستستغدم هذا الدومين؟'
          },
          warning: {
            title: 'يرجى الانتظار لمدة تتراوح من 1 إلى 3 دقائق حتى تتم إضافة النطاقات باستخدام SSL.'
          },
          offer: {
            title: 'حدد عرض خاص بالدومين'
          },
          store_choice: {
            options: {
              new_store: 'أنشاء متجر جديد',
              existing_store: 'أختيار متجر'
            }
          },
          language: {
            title: 'لغة المتجر',
            options: {
              english: 'الإنجليزية',
              arabic: 'العربية',
              spanish: 'الإسبانية',
              french: 'الفرنسية',
              italian: 'الإيتالية'
            }
          },
          name: {
            title: 'اسم الدومين',
            hint: 'يرجى ملء اسم الدومين الخاص بك فقط'
          },
          title: {
            title: 'عنوان تعريف الموقع',
            placeholder: 'اكتب عنوان تعريف الموقع'
          },
          email: {
            title: 'البريد الإلكتروني لدعم العملاء',
            step: 'معلومات الإتصال (إختياري - سيتم عرضها في أسفل المتجر و في صفحة الأتصال)',
            hint: 'الإفتراضي: contact@maxcomshop.com'
          },
          logo: {
            step: 'صورة الدومين و ألوانه',
            title: 'شعار موقع الويب (الحجم: 400 × 80 بكسل)'
          },
          tracking_data: {
            step: 'معلومات التتبع',
            title: 'البيكسلات'
          },
          favicon: {
            title: 'رمز أيقونة الموقع أو Favicon (الحجم: 32 × 32 بكسل)'
          },
          primary_color: {
            title: 'اللون الأساسي لدومين (غامق)'
          },
          secondary_color: {
            title: 'اللون الثانوي لدومين (فاتح)'
          },
          company_location: {
            title: 'عنوان الشركة',
            placeholder: 'عنوان الشركة...'
          },
          phone_number: {
            title: 'رقم الهاتف',
            placeholder: '123 456 789'
          }
        },
        buttons: {
          add: 'أضف الدومين',
          save: 'حفظ المجال',
          cancel: 'الغاء'
        }
      }
    },
    multiple_upload: {
      upload: 'رفع صورة',
      open_library: 'فتح المكتبة',
      upload_images: 'رفع الصور',
      please_select_images: 'الرجاء تحديد الصور الخاصة بك.',
      upload_videos: 'رفع مقاطع الفيديو',
      please_select_videos: 'الرجاء تحديد مقاطع الفيديو الخاصة بك.',
      library: 'مكتبة',
      upload_files: 'رفع الملفات'
    },
    confirmation_dialog: {
      yes: 'نعم',
      no: 'لا'
    },
    draggable_zone: {
      you_block_appear_here: 'ستظهر اجزاء صفحة البيع الخاصة بك هنا.',
      add_review: 'إضافة مراجعة'
    },
    dialog_upload: {
      please_wait: 'المرجو الانتظار...',
      upload_to_cloud: 'رفع إلى السحابة',
      or_choose_from: 'أو اختر من',
      library: 'المكتبة',
      upload_files: 'رفع ملفات'
    },
    header_block: {
      text: 'عنوان',
      form: {
        fields: {
          title: {
            title: 'العنوان',
            placeholder: 'اكتب العنوان الخاص بك'
          }
        }
      }
    },
    hero_block: {
      text: 'قسم البطل',
      form: {
        fields: {
          fill: {
            options: {
              home: 'قسم بطل الصفحة الرئسية'
            }
          },
          text: {
            title: 'وصف',
            placeholder: 'أكتب وصفًا...'
          },
          button_text: {
            title: 'إسم الزر',
            placeholder: 'إكتشف'
          },
          image: {
            title: 'صورة'
          }
        }
      }
    },
    block: {
      form: {
        fields: {
          fill: {
            fields: {
              ready_field: {
                placeholder: 'حدد المحتوى الجاهز'
              }
            },
            buttons: {
              fill: {
                title: 'إملئ'
              }
            }
          },
          block_visibility: 'إظهار الحواف',
          background_color: 'لون الخلفية',
          background: {
            is_enabled: 'اختر لون الخلفية الإختياري',
            color: 'لون الخلفية'
          },
          headline: {
            is_enabled: 'اختر لون العتوان الإختياري',
            color: 'لون العتوان'
          },
          head_line_color: 'لون العتوان',
          background_full_screen: 'الخلفية سيأخذ العرض كله',
          content_full_screen: 'الصورة تأخذ عرضها الكامل في الهاتف المحمول.',
          is_after_checkout: 'عرض الكتلة بعد نموذج الخروج.',
          is_background_gradient: 'تدرج الخلفية.',
          sticky: 'لاصق.'
        }
      }
    },
    bullet_block: {
      text: 'نقاط مهمة',
      form: {
        fields: {
          title: {
            title: 'العنوان',
            placeholder: 'اكتب العنوان الخاص بك'
          },
          bullet_one: {
            title: 'النقطية 1',
            placeholder: 'وظيفة 1 ...'
          },
          bullet_two: {
            title: 'النقطية 2',
            placeholder: 'وظيفة 2 ...'
          },
          bullet_three: {
            title: 'النقطية 3',
            placeholder: 'المنفعة 1 ...'
          },
          bullet_four: {
            title: 'النقطية 4',
            placeholder: 'المنفعة 2 ...'
          },
          bullet_five: {
            title: 'النقطية 5',
            placeholder: 'المواد والأقمشة ...'
          },
          image_max_width: {
            title: 'أقصى عرض للصورة',
            placeholder: 'حدد الحد الأقصى لالصورت',
            hint: 'ملاحظة: يوصى بتعيين قيمة بين 500 و 700'
          }
        }
      }
    },
    button_block: {
      text: 'زر الشراء',
      form: {
        text: {
          title: 'نص الزر',
          placeholder: 'اشتر الآن، اطلب الآن ...'
        },
        show_price: {
          title: 'إظهار الثمن'
        },
        under_button_text: {
          title: 'نص ما تحت الزر',
          placeholder: 'الدفع نقدا عند الاستلام'
        }
      }
    },
    gallery_block: {
      text: 'معرض الصور',
      trust_badges: {
        free_shipping: 'الشحن مجانا',
        return_guarantee: 'ضمان الإرجاع',
        secure_payment: 'شراء آمن',
        fast_support: 'دعم سريع'
      },
      form: {
        fields: {
          title: {
            title: 'العنوان',
            placeholder: 'اكتب العنوان الخاص بك'
          },
          product_name: {
            title: 'اسم المنتج القصير',
            placeholder: 'اكتب اسم المنتج القصير الخاص بك'
          },
          image: {
            title: 'الصور'
          },
          bullet_one: {
            title: 'النقطية 1',
            placeholder: 'وظيفة 1 ...'
          },
          bullet_two: {
            title: 'النقطية 2',
            placeholder: 'وظيفة 2 ...'
          },
          bullet_three: {
            title: 'النقطية 3',
            placeholder: 'المنفعة 1 ...'
          },
          bullet_four: {
            title: 'النقطية 4',
            placeholder: 'المنفعة 2 ...'
          },
          bullet_five: {
            title: 'النقطية 5',
            placeholder: 'المواد والأقمشة ...'
          },
          button: {
            title: 'نص الزر',
            placeholder: 'اشتر الآن ، اطلب الآن ...'
          },
          under_button: {
            title: 'نص ما تحت الزر',
            placeholder: 'الدفع نقدا عند الاستلام'
          }
        }
      }
    },
    brand_domain_block: {
      text: 'محتوى مجال العلامة التجارية',
      page_will_be_displayed_automatically: 'سيتم عرض الصفحة تلقائيا.',
      select_page: 'من فضلك قم باختيار صفحتك المخصصة.',
      form: {
        fields: {
          fill: {
            options: {
              discover_products: 'اكتشف منتجاتنا'
            }
          },
          page_select_type: {
            title: 'نوع عرض الصفحة'
          },
          page: {
            title: 'صفحة البيع',
            placeholder: 'اختر "تلقائيًا" أو صفحة بيع واحدة.'
          }
        }
      }
    },
    product_list_block: {
      text: 'قائمة المنتجات',
      products_will_be_displayed_automatically: 'سيتم إظهار المنتجات أوتوماتيكيا.',
      select_offers: 'المرجوا إختيار المنتجات.',
      form: {
        fields: {
          fill: {
            options: {
              discover_products: 'إكتشف منتجاتنا'
            }
          },
          title: {
            title: 'العنوان',
            placeholder: 'إكتشف منتجاتنا...'
          },
          list_select_type: {
            title: 'طريقة عرض القائمة'
          },
          product_list: {
            title: 'قائمة المنتجات',
            placeholder: 'اختر "تلقائيًا" أو منتجًا واحدًا أو منتجات متعددة.'
          },
          list: {
            title: 'قائمة المنتجات',
            placeholder: 'إختر طريقة عرض أوتوماتيكة أو أضف العروض مباشرة'
          }
        }
      }
    },
    article_block: {
      text: 'مقالة',
      form: {
        fields: {
          fill: {
            options: {
              about: 'حول كتلة الصفحة',
              refund_policy: 'صفحة سياسة الاسترداد',
              privacy_policy: 'كتلة صفحة سياسة الخصوصية',
              service_terms: 'كتلة صفحة شروط الخدمة',
              shipping_and_return: 'كتلة صفحة الشحن والإرجاع'
            }
          },
          title: {
            title: 'العنوان',
            placeholder: 'أكتب عنوانا'
          },
          content: {
            title: 'النص',
            placeholder: 'أكتب النص'
          }
        }
      }
    },
    contact_block: {
      text: 'نص الاتصال',
      form: {
        fields: {
          fill: {
            options: {
              contact: 'كتلة الاتصال بصفحة الاتصال'
            }
          },
          title: {
            title: 'العنوان',
            placeholder: 'اكتب عنوانًا'
          },
          content: {
            title: 'المحتوى',
            placeholder: 'اكتب المحتوى'
          }
        }
      }
    },
    navigation_link_block: {
      text: 'رابط',
      form: {
        fields: {
          link: {
            title: 'رابط'
          },
          name: {
            title: 'اسم'
          }
        }
      }
    },
    footer_links_block: {
      text: 'روابط الفوتر',
      form: {
        fields: {
          title: {
            title: 'عنوان'
          }
        }
      }
    },
    footer_info_block: {
      text: 'معلومات الفوتر',
      form: {
        fields: {
          domain_logo_visibility: 'شعار مرئي',
          domain_name_visibility: 'اسم النطاق مرئي',
          domain_email_visibility: 'البريد الإلكتروني للنطاق مرئي',
          domain_phone_visibility: 'هاتف المجال مرئي',
          domain_company_visibility: 'شركة المجال مرئية',
          social_medial_links: {
            title: 'روابط وسائل التواصل الاجتماعي',
            empty_text: 'تظهر روابط الوسائط الاجتماعية الخاصة بك هنا.',
            buttons: {
              add: 'إضافة رابط'
            }
          }
        }
      }
    },
    page_footer_block: {
      text: 'Page Footer',
      empty_text: 'your sections will appear here',
      buttons: {
        add: 'add Section'
      },
      form: {
        fields: {
          fill: {
            options: {
              default: 'Default Footer'
            }
          },
          list: {
            title: 'Section List'
          }
        }
      }
    },
    content_placeholder_block: {
      text: 'عنصر نائب للمحتوى',
      store_page: 'محتوى صفحة المتجر'
    },
    link_block: {
      text: 'رابط',
      form: {
        fields: {
          link: {
            title: 'رابط',
            placeholder: '/home'
          },
          name: {
            title: 'إسم',
            placeholder: 'الرئيسية'
          }
        }
      }
    },
    footer_benefits_block: {
      text: 'فوائد الفوتر',
      form: {
        fields: {
          paragraph: {
            title: 'نص'
          },
          features_image: {
            title: ''
          }
        }
      }
    },
    page_header_block: {
      text: 'رأس الصفحة',
      empty_text: 'ستظهر روابطك هنا',
      form: {
        fields: {
          fill: {
            options: {
              default: 'الرأس الافتراضي'
            }
          },
          links: {
            title: 'الروابط'
          }
        }
      },
      buttons: {
        add: 'إضافة رابط'
      }
    },
    social_media_link_block: {
      text: 'رابط وسائل التواصل الاجتماعي',
      form: {
        fields: {
          type: {
            title: 'نوع'
          },
          link: {
            title: 'رابط',
            placeholder: 'https://facebook.com/xxxx'
          }
        }
      }
    },
    compliance_bar_block: {
      text: 'شريط حقوق الطبع والنشر',
      form: {
        fields: {
          fill: {
            options: {
              default_compliance: 'حقوق الطبع والنشر'
            }
          },
          text: {
            title: 'نص',
            placeholder: 'اكتب نصًا'
          }
        }
      }
    },
    announcement_bar_block: {
      text: 'شريط الإعلانات',
      form: {
        fields: {
          fill: {
            options: {
              default_announcement: 'الشحن مجانا'
            }
          },
          text: {
            title: 'نص',
            placeholder: 'أكتب نصًا'
          }
        }
      }
    },
    journal_block: {
      text: 'نص (فقرة)',
      form: {
        fields: {
          block_visibility: {
            title: 'إظهار حواف المحتوى'
          },
          block_image_border_visibility: {
            title: 'إظهار حواف الصورة'
          },
          background_color: {
            title: 'لون الخلفية'
          },
          type: {
            title: 'إطهار المحتوى في'
          },
          title: {
            title: 'العنوان',
            placeholder: 'اكتب العنوان الخاص بك'
          },
          paragraph: {
            title: 'فقرة',
            placeholder: 'اكتب فقرتك'
          },
          image_max_width: {
            title: 'أقصى عرض للصورة',
            placeholder: 'حدد الحد الأقصى لصورة',
            hint: 'ملاحظة: يوصى بتعيين قيمة بين 400 و 700'
          }
        }
      }
    },
    faq_block: {
      text: 'سؤال وجواب',
      form: {
        fields: {
          block_visibility: {
            title: 'إظهار حواف المحتوى'
          },
          background_color: {
            title: 'لون الخلفية'
          },
          type: {
            title: 'إطهار المحتوى في'
          },
          title: {
            title: 'السؤال',
            placeholder: 'أكتب السؤال'
          },
          text: {
            title: 'الجواب',
            placeholder: 'أكتب الجواب'
          }
        }
      }
    },
    faqs_block: {
      text: 'أسئلة وأجوبة',
      form: {
        fields: {
          block_visibility: {
            title: 'إظهار حواف المحتوى'
          },
          background_color: {
            title: 'لون الخلفية'
          },
          type: {
            title: 'إطهار المحتوى في'
          },
          title: {
            title: 'العنوان',
            placeholder: 'أكتب العنوان'
          },
          faq_list: {
            title: 'قائمة الأسئلة والأجوبة'
          }
        },
        buttons: {
          add: 'إضافة سؤال'
        }
      }
    },
    figure_block: {
      text: 'عمود نص',
      form: {
        fields: {
          block_visibility: {
            title: 'إظهار حواف المحتوى'
          },
          background_color: {
            title: 'لون الخلفية'
          },
          type: {
            title: 'إطهار المحتوى في'
          },
          image: {
            title: 'صورة النص'
          },
          paragraph: {
            placeholder: 'محتوى النص'
          }
        }
      }
    },
    figures_block: {
      text: 'أعمدة النص',
      form: {
        fields: {
          block_visibility: {
            title: 'إظهار حواف المحتوى'
          },
          background_color: {
            title: 'لون الخلفية'
          },
          type: {
            title: 'إطهار المحتوى في'
          },
          figures_list: {
            title: 'قائمة أعمدة النص'
          }
        }
      },
      buttons: {
        add: 'إضافة عمود'
      }
    },
    reviews_block: {
      text: 'آراء العملاء',
      buttons: {
        add: 'اضافة مراجعة'
      },
      form: {
        fields: {
          block_visibility: {
            title: 'إظهار حواف المحتوى'
          },
          background_color: {
            title: 'لون الخلفية'
          },
          type: {
            title: 'إطهار المحتوى في'
          },
          title: {
            title: 'العنوان',
            placeholder: 'اكتب العنوان الخاص بك'
          },
          reviews_list: {
            title: 'قائمة الآراء'
          }
        }
      }
    },
    review_block: {
      text: 'رأي عميل',
      form: {
        fields: {
          block_visibility: {
            title: 'إظهار حواف المحتوى'
          },
          background_color: {
            title: 'لون الخلفية'
          },
          type: {
            title: 'إطهار المحتوى في'
          },
          profile_image: {
            title: 'صورة الملف الشخصي'
          },
          star_rating: {
            title: 'تقييم بالنجوم'
          },
          user_name: {
            title: 'اسم المستخدم',
            placeholder: 'اكتب اسم المستخدم الخاص بك'
          },
          text: {
            title: 'تعليق المراجعة',
            placeholder: 'اكتب تعليق المراجعة الخاص بك'
          },
          product_image: {
            title: 'صورة المنتج'
          }
        }
      }
    },
    simple_gallery_block: {
      text: 'معرض الصور البسيط',
      form: {
        fields: {
          block_visibility: {
            title: 'إظهار حواف المحتوى'
          },
          block_image_border_visibility: {
            title: 'إظهار حواف الصورة'
          },
          background_color: {
            title: 'لون الخلفية'
          },
          type: {
            title: 'إطهار المحتوى في'
          },
          title: {
            title: 'العنوان',
            placeholder: 'اكتب العنوان الخاص بك'
          },
          product_name: {
            title: 'اسم المنتج القصير',
            placeholder: 'اكتب اسم المنتج القصير الخاص بك'
          },
          bullet_one: {
            title: 'النقطية 1',
            placeholder: 'وظيفة 1 ...'
          },
          bullet_two: {
            title: 'النقطية 2',
            placeholder: 'وظيفة 2 ...'
          },
          bullet_three: {
            title: 'النقطية 3',
            placeholder: 'المنفعة 1 ...'
          },
          bullet_four: {
            title: 'النقطية 4',
            placeholder: 'المنفعة 2 ...'
          },
          bullet_five: {
            title: 'النقطية 5',
            placeholder: 'المواد والأقمشة ...'
          },
          text: {
            title: 'نص الزر',
            placeholder: 'اشتر الآن ، اطلب الآن ...'
          },
          under_button_text: {
            title: 'نص ما تحت الزر',
            placeholder: 'الدفع نقدا عند الاستلام'
          }
        }
      }
    },
    single_image_block: {
      text: 'صورة واحدة',
      form: {
        fields: {
          block_visibility: {
            title: 'إظهار حواف المحتوى'
          },
          block_image_border_visibility: {
            title: 'إظهار حواف الصورة'
          },
          background_color: {
            title: 'لون الخلفية'
          },
          type: {
            title: 'إطهار المحتوى في'
          },
          title: {
            title: 'العنوان',
            placeholder: 'اكتب العنوان الخاص بك'
          },
          vertical_spaces: {
            title: 'لا فراغات في الأعلى والأسفل'
          },
          mobile_horizontal_spaces: {
            title: 'لا فراغات على الجوانب (للجوال)'
          },
          image_max_width: {
            title: 'أقصى عرض للصورة',
            placeholder: 'حدد الحد الأقصى لالصورت',
            hint: 'ملاحظة: يوصى بتعيين قيمة بين 500 و 700'
          }
        }
      }
    },
    trust_block: {
      text: 'شارات مخصصة',
      buttons: {
        add: 'إضافة إشارة'
      },
      form: {
        fields: {
          fill: {
            options: {
              satisfaction_guarantee: 'رضاكم هو هدفنا'
            }
          },
          title: {
            title: 'العنوان'
          },
          paragraph: {
            title: 'عنوان فرعي'
          },
          badges_list: {
            title: 'قائمة الشارات'
          }
        }
      }
    },
    trust_badge_block: {
      text: 'شارة مخصصة',
      form: {
        fields: {
          image: {
            title: 'صورة الشارة'
          },
          text: {
            title: 'نص الصورة',
            placeholder: 'وصف الصورة...'
          }
        }
      }
    },
    video_block: {
      text: 'فيديو',
      form: {
        fields: {
          block_visibility: {
            title: 'إظهار حواف المحتوى'
          },
          background_color: {
            title: 'لون الخلفية'
          },
          type: {
            title: 'إطهار المحتوى في'
          },
          title: {
            title: 'العنوان',
            placeholder: 'اكتب العنوان الخاص بك'
          },
          video: {
            title: 'فيديو المنتج',
            placeholder: 'مثال: https://youtube.com?v=xxxx'
          }
        }
      }
    }
  }
};